/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { CustomerListDto, CustomerLocationDto, ProviderListDto, TicketNumberDto, User } from './common-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { ActivityCategory, DocumentListDto, EmailDetailInput, OnDemandEmailType, ProductListDto, UserListDto } from './shared-models';

@Injectable()
export class TicketServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTicket(body: CreateOrUpdateTicketInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateOrUpdateTicket';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateTicket(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateTicket(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateTicket(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param name (optional)
     * @return Success
     */
    getTicketSourceId(name: string | undefined): Observable<TicketSource> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketSourceId?';
        if (name === null) throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketSourceId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketSourceId(<any>response_);
                        } catch (e) {
                            return <Observable<TicketSource>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketSource>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketSourceId(response: HttpResponseBase): Observable<TicketSource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketSource.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketSource>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param quoteId (optional)
     * @return Success
     */
    createQuoteTicketAccount(ticketId: number | undefined, quoteId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateQuoteTicketAccount?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (quoteId === null) throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined) url_ += 'quoteId=' + encodeURIComponent('' + quoteId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateQuoteTicketAccount(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateQuoteTicketAccount(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateQuoteTicketAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param orderId (optional)
     * @return Success
     */
    createOrderTicketAccount(ticketId: number | undefined, orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateOrderTicketAccount?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrderTicketAccount(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrderTicketAccount(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrderTicketAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param partnerId (optional)
     * @param ticketAccount (optional)
     * @param ticketAccountType (optional)
     * @return Success
     */
    getTicketList(
        partnerId: number | undefined,
        ticketAccount: number | undefined,
        ticketAccountType: TicketAccountType | undefined
    ): Observable<TicketListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketList?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (ticketAccount === null) throw new Error("The parameter 'ticketAccount' cannot be null.");
        else if (ticketAccount !== undefined) url_ += 'TicketAccount=' + encodeURIComponent('' + ticketAccount) + '&';
        if (ticketAccountType === null) throw new Error("The parameter 'ticketAccountType' cannot be null.");
        else if (ticketAccountType !== undefined) url_ += 'TicketAccountType=' + encodeURIComponent('' + ticketAccountType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketList(<any>response_);
                        } catch (e) {
                            return <Observable<TicketListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketList(response: HttpResponseBase): Observable<TicketListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketListDto[]>([]);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param ticketNumber (optional)
     * @param ticketStatusIds (optional)
     * @param includeNullStatuses (optional)
     * @param departmentIds (optional)
     * @param includeNullDepartments (optional)
     * @param partnerIds (optional)
     * @param customerIds (optional)
     * @param locationIds (optional)
     * @param assignedUserId (optional)
     * @param providerId (optional)
     * @param ticketTypeId (optional)
     * @param subject (optional)
     * @param requestorUserId (optional)
     * @param requestorEmail (optional)
     * @param minStatusEffectiveDay (optional)
     * @param maxStatusEffectiveDay (optional)
     * @param strategicPartnerIds (optional)
     * @param investOwnerIds (optional)
     * @param ignoreCache (optional)
     * @param advisorEntitlementId (optional)
     * @param accountManagerIds (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getTicketsForTable(
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        ticketNumber: string | undefined,
        ticketStatusIds: string | undefined,
        includeNullStatuses: boolean | undefined,
        departmentIds: string | undefined,
        includeNullDepartments: boolean | undefined,
        partnerIds: string | undefined,
        customerIds: string | undefined,
        locationIds: string | undefined,
        assignedUserId: string | undefined,
        providerId: number | undefined,
        ticketTypeId: number | undefined,
        subject: string | undefined,
        requestorUserId: number | undefined,
        requestorEmail: string | undefined,
        minStatusEffectiveDay: number | undefined,
        maxStatusEffectiveDay: number | undefined,
        strategicPartnerIds: number[] | undefined,
        investOwnerIds: number[] | undefined,
        ignoreCache: boolean | undefined,
        advisorEntitlementId: number | undefined,
        accountManagerIds: number[] | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<TicketListOutputPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketsForTable?';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (ticketNumber === null) throw new Error("The parameter 'ticketNumber' cannot be null.");
        else if (ticketNumber !== undefined) url_ += 'TicketNumber=' + encodeURIComponent('' + ticketNumber) + '&';
        if (ticketStatusIds === null) throw new Error("The parameter 'ticketStatusIds' cannot be null.");
        else if (ticketStatusIds !== undefined) url_ += 'TicketStatusIds=' + encodeURIComponent('' + ticketStatusIds) + '&';
        if (includeNullStatuses === null) throw new Error("The parameter 'includeNullStatuses' cannot be null.");
        else if (includeNullStatuses !== undefined) url_ += 'IncludeNullStatuses=' + encodeURIComponent('' + includeNullStatuses) + '&';
        if (departmentIds === null) throw new Error("The parameter 'departmentIds' cannot be null.");
        else if (departmentIds !== undefined) url_ += 'DepartmentIds=' + encodeURIComponent('' + departmentIds) + '&';
        if (includeNullDepartments === null) throw new Error("The parameter 'includeNullDepartments' cannot be null.");
        else if (includeNullDepartments !== undefined)
            url_ += 'IncludeNullDepartments=' + encodeURIComponent('' + includeNullDepartments) + '&';
        if (partnerIds === null) throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined) url_ += 'PartnerIds=' + encodeURIComponent('' + partnerIds) + '&';
        if (customerIds === null) throw new Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined) url_ += 'CustomerIds=' + encodeURIComponent('' + customerIds) + '&';
        if (locationIds === null) throw new Error("The parameter 'locationIds' cannot be null.");
        else if (locationIds !== undefined) url_ += 'LocationIds=' + encodeURIComponent('' + locationIds) + '&';
        if (assignedUserId === null) throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined) url_ += 'AssignedUserId=' + encodeURIComponent('' + assignedUserId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (ticketTypeId === null) throw new Error("The parameter 'ticketTypeId' cannot be null.");
        else if (ticketTypeId !== undefined) url_ += 'TicketTypeId=' + encodeURIComponent('' + ticketTypeId) + '&';
        if (subject === null) throw new Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined) url_ += 'Subject=' + encodeURIComponent('' + subject) + '&';
        if (requestorUserId === null) throw new Error("The parameter 'requestorUserId' cannot be null.");
        else if (requestorUserId !== undefined) url_ += 'RequestorUserId=' + encodeURIComponent('' + requestorUserId) + '&';
        if (requestorEmail === null) throw new Error("The parameter 'requestorEmail' cannot be null.");
        else if (requestorEmail !== undefined) url_ += 'RequestorEmail=' + encodeURIComponent('' + requestorEmail) + '&';
        if (minStatusEffectiveDay === null) throw new Error("The parameter 'minStatusEffectiveDay' cannot be null.");
        else if (minStatusEffectiveDay !== undefined)
            url_ += 'MinStatusEffectiveDay=' + encodeURIComponent('' + minStatusEffectiveDay) + '&';
        if (maxStatusEffectiveDay === null) throw new Error("The parameter 'maxStatusEffectiveDay' cannot be null.");
        else if (maxStatusEffectiveDay !== undefined)
            url_ += 'MaxStatusEffectiveDay=' + encodeURIComponent('' + maxStatusEffectiveDay) + '&';
        if (strategicPartnerIds === null) throw new Error("The parameter 'strategicPartnerIds' cannot be null.");
        else if (strategicPartnerIds !== undefined)
            strategicPartnerIds &&
                strategicPartnerIds.forEach((item) => {
                    url_ += 'StrategicPartnerIds=' + encodeURIComponent('' + item) + '&';
                });
        if (investOwnerIds === null) throw new Error("The parameter 'investOwnerIds' cannot be null.");
        else if (investOwnerIds !== undefined)
            investOwnerIds &&
                investOwnerIds.forEach((item) => {
                    url_ += 'InvestOwnerIds=' + encodeURIComponent('' + item) + '&';
                });
        if (ignoreCache === null) throw new Error("The parameter 'ignoreCache' cannot be null.");
        else if (ignoreCache !== undefined) url_ += 'IgnoreCache=' + encodeURIComponent('' + ignoreCache) + '&';
        if (advisorEntitlementId === null) throw new Error("The parameter 'advisorEntitlementId' cannot be null.");
        else if (advisorEntitlementId !== undefined) url_ += 'AdvisorEntitlementId=' + encodeURIComponent('' + advisorEntitlementId) + '&';
        if (accountManagerIds === null) throw new Error("The parameter 'accountManagerIds' cannot be null.");
        else if (accountManagerIds !== undefined)
            accountManagerIds &&
                accountManagerIds.forEach((item) => {
                    url_ += 'AccountManagerIds=' + encodeURIComponent('' + item) + '&';
                });
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketsForTable(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketsForTable(<any>response_);
                        } catch (e) {
                            return <Observable<TicketListOutputPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketListOutputPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketsForTable(response: HttpResponseBase): Observable<TicketListOutputPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketListOutputPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketListOutputPagedResultDto>(<any>null);
    }

    /**
     * @param requestor (optional)
     * @return Success
     */
    getTicketRequestorUsers(requestor: string | undefined): Observable<TicketRequestorUserOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketRequestorUsers?';
        if (requestor === null) throw new Error("The parameter 'requestor' cannot be null.");
        else if (requestor !== undefined) url_ += 'requestor=' + encodeURIComponent('' + requestor) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketRequestorUsers(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketRequestorUsers(<any>response_);
                        } catch (e) {
                            return <Observable<TicketRequestorUserOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketRequestorUserOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketRequestorUsers(response: HttpResponseBase): Observable<TicketRequestorUserOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketRequestorUserOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketRequestorUserOutput[]>([]);
    }

    /**
     * @param departmentIds (optional)
     * @return Success
     */
    getTicketTypeList(departmentIds: number[] | undefined): Observable<TicketTypeListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketTypeList?';
        if (departmentIds === null) throw new Error("The parameter 'departmentIds' cannot be null.");
        else if (departmentIds !== undefined)
            departmentIds &&
                departmentIds.forEach((item) => {
                    url_ += 'departmentIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<TicketTypeListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketTypeListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketTypeList(response: HttpResponseBase): Observable<TicketTypeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketTypeListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketTypeListDto[]>([]);
    }

    /**
     * @param departmentIds (optional)
     * @return Success
     */
    getTicketResolutionList(departmentIds: number[] | undefined): Observable<TicketResolutionListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketResolutionList?';
        if (departmentIds === null) throw new Error("The parameter 'departmentIds' cannot be null.");
        else if (departmentIds !== undefined)
            departmentIds &&
                departmentIds.forEach((item) => {
                    url_ += 'departmentIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketResolutionList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketResolutionList(<any>response_);
                        } catch (e) {
                            return <Observable<TicketResolutionListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketResolutionListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketResolutionList(response: HttpResponseBase): Observable<TicketResolutionListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketResolutionListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketResolutionListDto[]>([]);
    }

    /**
     * @param departmentIds (optional)
     * @return Success
     */
    getTicketStatusList(departmentIds: number[] | undefined): Observable<TicketStatusListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketStatusList?';
        if (departmentIds === null) throw new Error("The parameter 'departmentIds' cannot be null.");
        else if (departmentIds !== undefined)
            departmentIds &&
                departmentIds.forEach((item) => {
                    url_ += 'departmentIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketStatusList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketStatusList(<any>response_);
                        } catch (e) {
                            return <Observable<TicketStatusListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketStatusListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketStatusList(response: HttpResponseBase): Observable<TicketStatusListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketStatusListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketStatusListDto[]>([]);
    }

    /**
     * @param ticketId (optional)
     * @return Success
     */
    getTicketForEdit(ticketId: number | undefined): Observable<GetTicketForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketForEdit?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetTicketForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetTicketForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketForEdit(response: HttpResponseBase): Observable<GetTicketForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetTicketForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetTicketForEditOutput>(<any>null);
    }

    /**
     * @param ticketNumber (optional)
     * @return Success
     */
    getTicketByTicketNumber(ticketNumber: string | undefined): Observable<TicketEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketByTicketNumber?';
        if (ticketNumber === null) throw new Error("The parameter 'ticketNumber' cannot be null.");
        else if (ticketNumber !== undefined) url_ += 'ticketNumber=' + encodeURIComponent('' + ticketNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketByTicketNumber(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketByTicketNumber(<any>response_);
                        } catch (e) {
                            return <Observable<TicketEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketByTicketNumber(response: HttpResponseBase): Observable<TicketEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    mergeTicket(body: MergeTicketInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/MergeTicket';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processMergeTicket(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processMergeTicket(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processMergeTicket(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param ticketResolutionId (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmailAndCloseTicket(
        ticketId: number | undefined,
        ticketResolutionId: number | undefined,
        body: EmailDetailInput | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/SendEmailAndCloseTicket?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (ticketResolutionId === null) throw new Error("The parameter 'ticketResolutionId' cannot be null.");
        else if (ticketResolutionId !== undefined) url_ += 'ticketResolutionId=' + encodeURIComponent('' + ticketResolutionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendEmailAndCloseTicket(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendEmailAndCloseTicket(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendEmailAndCloseTicket(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param ticketStatusId (optional)
     * @param body (optional)
     * @return Success
     */
    sendEmailAndUpdateTicket(
        ticketId: number | undefined,
        ticketStatusId: number | undefined,
        body: EmailDetailInput | undefined
    ): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/SendEmailAndUpdateTicket?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (ticketStatusId === null) throw new Error("The parameter 'ticketStatusId' cannot be null.");
        else if (ticketStatusId !== undefined) url_ += 'ticketStatusId=' + encodeURIComponent('' + ticketStatusId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendEmailAndUpdateTicket(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendEmailAndUpdateTicket(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendEmailAndUpdateTicket(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @return Success
     */
    updateTicketStatusByAutomation(ticketId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketStatusByAutomation?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketStatusByAutomation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketStatusByAutomation(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketStatusByAutomation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param subject (optional)
     * @return Success
     */
    updateTicketSubject(ticketId: number | undefined, subject: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketSubject?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (subject === null) throw new Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined) url_ += 'subject=' + encodeURIComponent('' + subject) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketSubject(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketSubject(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketSubject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param description (optional)
     * @return Success
     */
    updateTicketDescription(ticketId: number | undefined, description: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketDescription?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (description === null) throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined) url_ += 'description=' + encodeURIComponent('' + description) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketDescription(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketDescription(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketDescription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param ticketStatusId (optional)
     * @return Success
     */
    updateTicketStatus(ticketId: number | undefined, ticketStatusId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketStatus?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (ticketStatusId === null) throw new Error("The parameter 'ticketStatusId' cannot be null.");
        else if (ticketStatusId !== undefined) url_ += 'ticketStatusId=' + encodeURIComponent('' + ticketStatusId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketStatus(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketStatus(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @return Success
     */
    updateTicketStatusToClose(ticketId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketStatusToClose?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketStatusToClose(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketStatusToClose(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketStatusToClose(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTicketDepartment(body: TicketDepartmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketDepartment';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketDepartment(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketDepartment(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketDepartment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param ticketSourceId (optional)
     * @return Success
     */
    updateTicketSource(ticketId: number | undefined, ticketSourceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketSource?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (ticketSourceId === null) throw new Error("The parameter 'ticketSourceId' cannot be null.");
        else if (ticketSourceId !== undefined) url_ += 'ticketSourceId=' + encodeURIComponent('' + ticketSourceId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketSource(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketSource(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketSource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param assignedUserId (optional)
     * @return Success
     */
    updateTicketAssignUser(ticketId: number | undefined, assignedUserId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketAssignUser?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (assignedUserId === null) throw new Error("The parameter 'assignedUserId' cannot be null.");
        else if (assignedUserId !== undefined) url_ += 'assignedUserId=' + encodeURIComponent('' + assignedUserId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketAssignUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketAssignUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketAssignUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param ticketPriorityId (optional)
     * @return Success
     */
    updateTicketPriority(ticketId: number | undefined, ticketPriorityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketPriority?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (ticketPriorityId === null) throw new Error("The parameter 'ticketPriorityId' cannot be null.");
        else if (ticketPriorityId !== undefined) url_ += 'ticketPriorityId=' + encodeURIComponent('' + ticketPriorityId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketPriority(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketPriority(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketPriority(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param ticketTypeId (optional)
     * @return Success
     */
    updateTicketType(ticketId: number | undefined, ticketTypeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketType?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (ticketTypeId === null) throw new Error("The parameter 'ticketTypeId' cannot be null.");
        else if (ticketTypeId !== undefined) url_ += 'ticketTypeId=' + encodeURIComponent('' + ticketTypeId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param ticketResolutionId (optional)
     * @return Success
     */
    updateTicketResolution(ticketId: number | undefined, ticketResolutionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketResolution?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (ticketResolutionId === null) throw new Error("The parameter 'ticketResolutionId' cannot be null.");
        else if (ticketResolutionId !== undefined) url_ += 'ticketResolutionId=' + encodeURIComponent('' + ticketResolutionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketResolution(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketResolution(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketResolution(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param partnerId (optional)
     * @return Success
     */
    updateTicketPartner(ticketId: number | undefined, partnerId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketPartner?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketPartner(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketPartner(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketPartner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param customerId (optional)
     * @return Success
     */
    updateTicketCompany(ticketId: number | undefined, customerId: number | undefined): Observable<TicketAccountForCustomerDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketCompany?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'customerId=' + encodeURIComponent('' + customerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketCompany(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketCompany(<any>response_);
                        } catch (e) {
                            return <Observable<TicketAccountForCustomerDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketAccountForCustomerDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketCompany(response: HttpResponseBase): Observable<TicketAccountForCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketAccountForCustomerDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketAccountForCustomerDto>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param locationId (optional)
     * @return Success
     */
    updateTicketLocation(ticketId: number | undefined, locationId: number | undefined): Observable<TicketAccountForLocationDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketLocation?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (locationId === null) throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined) url_ += 'locationId=' + encodeURIComponent('' + locationId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketLocation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketLocation(<any>response_);
                        } catch (e) {
                            return <Observable<TicketAccountForLocationDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketAccountForLocationDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketLocation(response: HttpResponseBase): Observable<TicketAccountForLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketAccountForLocationDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketAccountForLocationDto>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param productId (optional)
     * @return Success
     */
    updateTicketProduct(ticketId: number | undefined, productId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketProduct?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'productId=' + encodeURIComponent('' + productId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketProduct(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketProduct(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param body (optional)
     * @return Success
     */
    updateTicketProvider(ticketId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketProvider?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketProvider(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketProvider(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketProvider(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param requestorId (optional)
     * @param email (optional)
     * @return Success
     */
    updateTicketRequestor(ticketId: number | undefined, requestorId: number | undefined, email: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketRequestor?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (requestorId === null) throw new Error("The parameter 'requestorId' cannot be null.");
        else if (requestorId !== undefined) url_ += 'requestorId=' + encodeURIComponent('' + requestorId) + '&';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketRequestor(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketRequestor(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketRequestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param email (optional)
     * @return Success
     */
    updateTicketRequestorEmail(ticketId: number | undefined, email: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/UpdateTicketRequestorEmail?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateTicketRequestorEmail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateTicketRequestorEmail(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateTicketRequestorEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @param productId (optional)
     * @return Success
     */
    deleteTicketProduct(ticketId: number | undefined, productId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketProduct?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        if (productId === null) throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined) url_ += 'productId=' + encodeURIComponent('' + productId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketProduct(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketProduct(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @return Success
     */
    deleteTicketPartner(ticketId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketPartner?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketPartner(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketPartner(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketPartner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @return Success
     */
    deleteTicketCompany(ticketId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketCompany?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketCompany(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketCompany(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @return Success
     */
    deleteTicketLocation(ticketId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketLocation?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketLocation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketLocation(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTicket(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicket?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicket(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicket(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicket(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @return Success
     */
    getTicketLatestNote(ticketId: number | undefined): Observable<LatestTicketNoteOutput> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketLatestNote?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketLatestNote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketLatestNote(<any>response_);
                        } catch (e) {
                            return <Observable<LatestTicketNoteOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<LatestTicketNoteOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketLatestNote(response: HttpResponseBase): Observable<LatestTicketNoteOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = LatestTicketNoteOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<LatestTicketNoteOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createTicketFromEmailByPassFilters(body: CreateTicketFromEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateTicketFromEmailByPassFilters';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateTicketFromEmailByPassFilters(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateTicketFromEmailByPassFilters(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateTicketFromEmailByPassFilters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param authorization (optional)
     * @param isMobile (optional)
     * @param body (optional)
     * @return Success
     */
    createTicketFromEmail(
        authorization: string | undefined,
        isMobile: boolean | undefined,
        body: CreateTicketFromEmailInput | undefined
    ): Observable<CreateTicketFromEmailOutput> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateTicketFromEmail?';
        if (isMobile === null) throw new Error("The parameter 'isMobile' cannot be null.");
        else if (isMobile !== undefined) url_ += 'isMobile=' + encodeURIComponent('' + isMobile) + '&';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                authorization: authorization !== undefined && authorization !== null ? '' + authorization : '',
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateTicketFromEmail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateTicketFromEmail(<any>response_);
                        } catch (e) {
                            return <Observable<CreateTicketFromEmailOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CreateTicketFromEmailOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateTicketFromEmail(response: HttpResponseBase): Observable<CreateTicketFromEmailOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CreateTicketFromEmailOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CreateTicketFromEmailOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getTicketSourceList(): Observable<TicketSourceDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketSourceList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketSourceList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketSourceList(<any>response_);
                        } catch (e) {
                            return <Observable<TicketSourceDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketSourceDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketSourceList(response: HttpResponseBase): Observable<TicketSourceDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketSourceDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketSourceDropdownDto[]>([]);
    }

    /**
     * @param quoteId (optional)
     * @return Success
     */
    getTicketForQuote(quoteId: number | undefined): Observable<GetTickeForQuoteAndOrder> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketForQuote?';
        if (quoteId === null) throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined) url_ += 'quoteId=' + encodeURIComponent('' + quoteId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketForQuote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketForQuote(<any>response_);
                        } catch (e) {
                            return <Observable<GetTickeForQuoteAndOrder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetTickeForQuoteAndOrder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketForQuote(response: HttpResponseBase): Observable<GetTickeForQuoteAndOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetTickeForQuoteAndOrder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetTickeForQuoteAndOrder>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    getTicketForOrder(orderId: number | undefined): Observable<TicketNumberDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketForOrder?';
        if (orderId === null) throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined) url_ += 'orderId=' + encodeURIComponent('' + orderId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketForOrder(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketForOrder(<any>response_);
                        } catch (e) {
                            return <Observable<TicketNumberDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketNumberDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketForOrder(response: HttpResponseBase): Observable<TicketNumberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketNumberDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketNumberDto[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param departmentId (optional)
     * @return Success
     */
    getTicketRequestorListByPartner(
        partnerId: number | undefined,
        departmentId: number | undefined
    ): Observable<TicketRequestorDropdownDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketRequestorListByPartner?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (departmentId === null) throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined) url_ += 'departmentId=' + encodeURIComponent('' + departmentId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketRequestorListByPartner(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketRequestorListByPartner(<any>response_);
                        } catch (e) {
                            return <Observable<TicketRequestorDropdownDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketRequestorDropdownDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketRequestorListByPartner(response: HttpResponseBase): Observable<TicketRequestorDropdownDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketRequestorDropdownDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketRequestorDropdownDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrderTicket(body: CreateOrderTicketInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateOrderTicket';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrderTicket(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrderTicket(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrderTicket(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createCommissionTicket(body: CreateCommissionTicketInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateCommissionTicket';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateCommissionTicket(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateCommissionTicket(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateCommissionTicket(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param ticketNumber (optional)
     * @param customerName (optional)
     * @param location (optional)
     * @param productName (optional)
     * @param providerNames (optional)
     * @param description (optional)
     * @param ticketId (optional)
     * @param cannedResponse (optional)
     * @return Success
     */
    getTicketEmailTemplate(
        ticketNumber: string | undefined,
        customerName: string | undefined,
        location: string | undefined,
        productName: string | undefined,
        providerNames: string[] | undefined,
        description: string | undefined,
        ticketId: string | undefined,
        cannedResponse: string | undefined
    ): Observable<TicketEmailTemplateOutput> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketEmailTemplate?';
        if (ticketNumber === null) throw new Error("The parameter 'ticketNumber' cannot be null.");
        else if (ticketNumber !== undefined) url_ += 'TicketNumber=' + encodeURIComponent('' + ticketNumber) + '&';
        if (customerName === null) throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined) url_ += 'CustomerName=' + encodeURIComponent('' + customerName) + '&';
        if (location === null) throw new Error("The parameter 'location' cannot be null.");
        else if (location !== undefined) url_ += 'Location=' + encodeURIComponent('' + location) + '&';
        if (productName === null) throw new Error("The parameter 'productName' cannot be null.");
        else if (productName !== undefined) url_ += 'ProductName=' + encodeURIComponent('' + productName) + '&';
        if (providerNames === null) throw new Error("The parameter 'providerNames' cannot be null.");
        else if (providerNames !== undefined)
            providerNames &&
                providerNames.forEach((item) => {
                    url_ += 'ProviderNames=' + encodeURIComponent('' + item) + '&';
                });
        if (description === null) throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined) url_ += 'Description=' + encodeURIComponent('' + description) + '&';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'TicketId=' + encodeURIComponent('' + ticketId) + '&';
        if (cannedResponse === null) throw new Error("The parameter 'cannedResponse' cannot be null.");
        else if (cannedResponse !== undefined) url_ += 'CannedResponse=' + encodeURIComponent('' + cannedResponse) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketEmailTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketEmailTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<TicketEmailTemplateOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketEmailTemplateOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketEmailTemplate(response: HttpResponseBase): Observable<TicketEmailTemplateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketEmailTemplateOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketEmailTemplateOutput>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getTicketTypeAdminList(filter: string | undefined): Observable<TicketTypeAdminListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketTypeAdminList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketTypeAdminList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketTypeAdminList(<any>response_);
                        } catch (e) {
                            return <Observable<TicketTypeAdminListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketTypeAdminListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketTypeAdminList(response: HttpResponseBase): Observable<TicketTypeAdminListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketTypeAdminListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketTypeAdminListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTicketTypeForEdit(id: number | undefined): Observable<TicketTypeAdminEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketTypeForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketTypeForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketTypeForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<TicketTypeAdminEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketTypeAdminEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketTypeForEdit(response: HttpResponseBase): Observable<TicketTypeAdminEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketTypeAdminEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketTypeAdminEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTicketType(body: CreateOrUpdateTicketTypeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateOrUpdateTicketType';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateTicketType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateTicketType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateTicketType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTicketType(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketType?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketType(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketType(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getTicketSources(filter: string | undefined): Observable<TicketSourceListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketSources?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketSources(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketSources(<any>response_);
                        } catch (e) {
                            return <Observable<TicketSourceListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketSourceListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketSources(response: HttpResponseBase): Observable<TicketSourceListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketSourceListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketSourceListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTicketSourceForEdit(id: number | undefined): Observable<TicketSourceEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketSourceForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketSourceForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketSourceForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<TicketSourceEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketSourceEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketSourceForEdit(response: HttpResponseBase): Observable<TicketSourceEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketSourceEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketSourceEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTicketSource(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketSource?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketSource(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketSource(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketSource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTicketSource(body: CreateOrUpdateTicketSourceInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateOrUpdateTicketSource';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateTicketSource(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateTicketSource(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateTicketSource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getTicketStatuses(filter: string | undefined): Observable<TicketStatusListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketStatuses?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketStatuses(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketStatuses(<any>response_);
                        } catch (e) {
                            return <Observable<TicketStatusListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketStatusListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketStatuses(response: HttpResponseBase): Observable<TicketStatusListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketStatusListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketStatusListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTicketStatusForEdit(id: number | undefined): Observable<TicketStatusEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketStatusForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketStatusForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketStatusForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<TicketStatusEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketStatusEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketStatusForEdit(response: HttpResponseBase): Observable<TicketStatusEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketStatusEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketStatusEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTicketStatus(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketStatus?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketStatus(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketStatus(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTicketStatus(body: CreateOrUpdateTicketStatusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateOrUpdateTicketStatus';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateTicketStatus(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateTicketStatus(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateTicketStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getTicketResolutionAdminList(filter: string | undefined): Observable<TicketResolutionAdminListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketResolutionAdminList?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketResolutionAdminList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketResolutionAdminList(<any>response_);
                        } catch (e) {
                            return <Observable<TicketResolutionAdminListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketResolutionAdminListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketResolutionAdminList(response: HttpResponseBase): Observable<TicketResolutionAdminListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketResolutionAdminListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketResolutionAdminListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTicketResolutionAdminForEdit(id: number | undefined): Observable<TicketResolutionAdminEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketResolutionAdminForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketResolutionAdminForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketResolutionAdminForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<TicketResolutionAdminEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketResolutionAdminEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketResolutionAdminForEdit(response: HttpResponseBase): Observable<TicketResolutionAdminEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketResolutionAdminEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketResolutionAdminEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTicketResolutionAdmin(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketResolutionAdmin?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketResolutionAdmin(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketResolutionAdmin(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketResolutionAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTicketResolutionAdmin(body: CreateOrUpdateTicketResolutionAdminInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateOrUpdateTicketResolutionAdmin';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateTicketResolutionAdmin(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateTicketResolutionAdmin(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateTicketResolutionAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getTicketAdminActions(filter: string | undefined): Observable<AdminTicketActionListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketAdminActions?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketAdminActions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketAdminActions(<any>response_);
                        } catch (e) {
                            return <Observable<AdminTicketActionListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<AdminTicketActionListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketAdminActions(response: HttpResponseBase): Observable<AdminTicketActionListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(AdminTicketActionListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<AdminTicketActionListDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTicketAction(body: CreateOrUpdateTicketActionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/CreateOrUpdateTicketAction';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateTicketAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateTicketAction(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateTicketAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTicketAction(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/DeleteTicketAction?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketAction(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketAction(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTicketActionForEdit(id: number | undefined): Observable<TicketActionAdminEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketActionForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketActionForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketActionForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<TicketActionAdminEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketActionAdminEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketActionForEdit(response: HttpResponseBase): Observable<TicketActionAdminEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketActionAdminEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketActionAdminEditDto>(<any>null);
    }

    /**
     * @param departmentIds (optional)
     * @param userIds (optional)
     * @param roleIds (optional)
     * @param partnerId (optional)
     * @param providerId (optional)
     * @param isProviderStatus (optional)
     * @param supervisorId (optional)
     * @return Success
     */
    getTicketStatusDashboard(
        departmentIds: number[] | undefined,
        userIds: number[] | undefined,
        roleIds: number[] | undefined,
        partnerId: number | undefined,
        providerId: number | undefined,
        isProviderStatus: boolean | undefined,
        supervisorId: number | undefined
    ): Observable<TicketStatusDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Ticket/GetTicketStatusDashboard?';
        if (departmentIds === null) throw new Error("The parameter 'departmentIds' cannot be null.");
        else if (departmentIds !== undefined)
            departmentIds &&
                departmentIds.forEach((item) => {
                    url_ += 'departmentIds=' + encodeURIComponent('' + item) + '&';
                });
        if (userIds === null) throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds &&
                userIds.forEach((item) => {
                    url_ += 'userIds=' + encodeURIComponent('' + item) + '&';
                });
        if (roleIds === null) throw new Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds &&
                roleIds.forEach((item) => {
                    url_ += 'roleIds=' + encodeURIComponent('' + item) + '&';
                });
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        if (isProviderStatus === null) throw new Error("The parameter 'isProviderStatus' cannot be null.");
        else if (isProviderStatus !== undefined) url_ += 'isProviderStatus=' + encodeURIComponent('' + isProviderStatus) + '&';
        if (supervisorId === null) throw new Error("The parameter 'supervisorId' cannot be null.");
        else if (supervisorId !== undefined) url_ += 'supervisorId=' + encodeURIComponent('' + supervisorId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketStatusDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketStatusDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<TicketStatusDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketStatusDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketStatusDashboard(response: HttpResponseBase): Observable<TicketStatusDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketStatusDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketStatusDashboardOutput[]>([]);
    }
}

@Injectable()
export class TicketEmailBodyBuilderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param userName (optional)
     * @return Success
     */
    withLoggedInUserName(userName: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithLoggedInUserName?';
        if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithLoggedInUserName(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithLoggedInUserName(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithLoggedInUserName(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param cannedResponse (optional)
     * @return Success
     */
    withCannedResponse(cannedResponse: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithCannedResponse?';
        if (cannedResponse === null) throw new Error("The parameter 'cannedResponse' cannot be null.");
        else if (cannedResponse !== undefined) url_ += 'cannedResponse=' + encodeURIComponent('' + cannedResponse) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithCannedResponse(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithCannedResponse(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithCannedResponse(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param ticketNumber (optional)
     * @return Success
     */
    withTicketNumber(ticketNumber: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithTicketNumber?';
        if (ticketNumber === null) throw new Error("The parameter 'ticketNumber' cannot be null.");
        else if (ticketNumber !== undefined) url_ += 'ticketNumber=' + encodeURIComponent('' + ticketNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithTicketNumber(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithTicketNumber(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithTicketNumber(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param ticketId (optional)
     * @return Success
     */
    withTicketId(ticketId: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithTicketId?';
        if (ticketId === null) throw new Error("The parameter 'ticketId' cannot be null.");
        else if (ticketId !== undefined) url_ += 'ticketId=' + encodeURIComponent('' + ticketId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithTicketId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithTicketId(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithTicketId(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param customer (optional)
     * @return Success
     */
    withCustomer(customer: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithCustomer?';
        if (customer === null) throw new Error("The parameter 'customer' cannot be null.");
        else if (customer !== undefined) url_ += 'customer=' + encodeURIComponent('' + customer) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithCustomer(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param location (optional)
     * @return Success
     */
    withLocation(location: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithLocation?';
        if (location === null) throw new Error("The parameter 'location' cannot be null.");
        else if (location !== undefined) url_ += 'location=' + encodeURIComponent('' + location) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithLocation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithLocation(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithLocation(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param product (optional)
     * @return Success
     */
    withProduct(product: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithProduct?';
        if (product === null) throw new Error("The parameter 'product' cannot be null.");
        else if (product !== undefined) url_ += 'product=' + encodeURIComponent('' + product) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithProduct(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithProduct(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithProduct(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param provider (optional)
     * @return Success
     */
    withProvider(provider: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithProvider?';
        if (provider === null) throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined) url_ += 'provider=' + encodeURIComponent('' + provider) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithProvider(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithProvider(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithProvider(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param description (optional)
     * @return Success
     */
    withDescription(description: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithDescription?';
        if (description === null) throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined) url_ += 'description=' + encodeURIComponent('' + description) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithDescription(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithDescription(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithDescription(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param ticketrUrlTemplate (optional)
     * @return Success
     */
    withViewTicketUrl(ticketrUrlTemplate: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithViewTicketUrl?';
        if (ticketrUrlTemplate === null) throw new Error("The parameter 'ticketrUrlTemplate' cannot be null.");
        else if (ticketrUrlTemplate !== undefined) url_ += 'ticketrUrlTemplate=' + encodeURIComponent('' + ticketrUrlTemplate) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithViewTicketUrl(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithViewTicketUrl(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithViewTicketUrl(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withBaseTemplate(body: any | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithBaseTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithBaseTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithBaseTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithBaseTemplate(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withBodyTemplate(body: any | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithBodyTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithBodyTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithBodyTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithBodyTemplate(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param headerText (optional)
     * @return Success
     */
    withHeader(headerText: string | undefined): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithHeader?';
        if (headerText === null) throw new Error("The parameter 'headerText' cannot be null.");
        else if (headerText !== undefined) url_ += 'headerText=' + encodeURIComponent('' + headerText) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithHeader(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithHeader(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithHeader(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }

    /**
     * @param shouldThrow (optional)
     * @return Success
     */
    build(shouldThrow: boolean | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/Build?';
        if (shouldThrow === null) throw new Error("The parameter 'shouldThrow' cannot be null.");
        else if (shouldThrow !== undefined) url_ += 'shouldThrow=' + encodeURIComponent('' + shouldThrow) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processBuild(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processBuild(<any>response_);
                        } catch (e) {
                            return <Observable<any>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<any>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processBuild(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    validateBodyTemplatePlaceholders(body: any | undefined): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/ValidateBodyTemplatePlaceholders';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processValidateBodyTemplatePlaceholders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processValidateBodyTemplatePlaceholders(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processValidateBodyTemplatePlaceholders(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param title (optional)
     * @param email (optional)
     * @param phoneNumber (optional)
     * @return Success
     */
    withAssignedUserInfo(
        title: string | undefined,
        email: string | undefined,
        phoneNumber: string | undefined
    ): Observable<ITicketEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/TicketEmailBodyBuilder/WithAssignedUserInfo?';
        if (title === null) throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined) url_ += 'title=' + encodeURIComponent('' + title) + '&';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        if (phoneNumber === null) throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined) url_ += 'phoneNumber=' + encodeURIComponent('' + phoneNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithAssignedUserInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithAssignedUserInfo(<any>response_);
                        } catch (e) {
                            return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ITicketEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithAssignedUserInfo(response: HttpResponseBase): Observable<ITicketEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ITicketEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ITicketEmailBodyBuilder>(<any>null);
    }
}

@Injectable()
export class TicketNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getTicketNotifications(): Observable<TicketNotificationDto[]> {
        let url_ = this.baseUrl + '/api/services/app/TicketNotification/GetTicketNotifications';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketNotifications(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketNotifications(<any>response_);
                        } catch (e) {
                            return <Observable<TicketNotificationDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketNotificationDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketNotifications(response: HttpResponseBase): Observable<TicketNotificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketNotificationDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketNotificationDto[]>([]);
    }

    /**
     * @param ticketNotificationId (optional)
     * @return Success
     */
    getTicketNotification(ticketNotificationId: number | undefined): Observable<TicketNotificationDto> {
        let url_ = this.baseUrl + '/api/services/app/TicketNotification/GetTicketNotification?';
        if (ticketNotificationId === null) throw new Error("The parameter 'ticketNotificationId' cannot be null.");
        else if (ticketNotificationId !== undefined) url_ += 'ticketNotificationId=' + encodeURIComponent('' + ticketNotificationId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketNotification(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketNotification(<any>response_);
                        } catch (e) {
                            return <Observable<TicketNotificationDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketNotificationDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketNotification(response: HttpResponseBase): Observable<TicketNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketNotificationDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketNotificationDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTicketNotification(body: TicketNotificationEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/TicketNotification/CreateOrUpdateTicketNotification';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateTicketNotification(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateTicketNotification(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateTicketNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ticketNotificationId (optional)
     * @return Success
     */
    deleteTicketNotification(ticketNotificationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/TicketNotification/DeleteTicketNotification?';
        if (ticketNotificationId === null) throw new Error("The parameter 'ticketNotificationId' cannot be null.");
        else if (ticketNotificationId !== undefined) url_ += 'ticketNotificationId=' + encodeURIComponent('' + ticketNotificationId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteTicketNotification(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteTicketNotification(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteTicketNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TicketWorkflowAutomationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getTicketWorkflowAutomations(): Observable<TicketWorkflowAutomationDto[]> {
        let url_ = this.baseUrl + '/api/services/app/TicketWorkflowAutomation/GetTicketWorkflowAutomations';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetTicketWorkflowAutomations(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetTicketWorkflowAutomations(<any>response_);
                        } catch (e) {
                            return <Observable<TicketWorkflowAutomationDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketWorkflowAutomationDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetTicketWorkflowAutomations(response: HttpResponseBase): Observable<TicketWorkflowAutomationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(TicketWorkflowAutomationDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketWorkflowAutomationDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateWorkflowAutomation(body: TicketWorkflowAutomationEditDto | undefined): Observable<TicketWorkflowAutomationDto> {
        let url_ = this.baseUrl + '/api/services/app/TicketWorkflowAutomation/CreateOrUpdateWorkflowAutomation';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateWorkflowAutomation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateWorkflowAutomation(<any>response_);
                        } catch (e) {
                            return <Observable<TicketWorkflowAutomationDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<TicketWorkflowAutomationDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateWorkflowAutomation(response: HttpResponseBase): Observable<TicketWorkflowAutomationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = TicketWorkflowAutomationDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<TicketWorkflowAutomationDto>(<any>null);
    }

    /**
     * @param automationId (optional)
     * @return Success
     */
    deleteWorkflowAutomation(automationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/TicketWorkflowAutomation/DeleteWorkflowAutomation?';
        if (automationId === null) throw new Error("The parameter 'automationId' cannot be null.");
        else if (automationId !== undefined) url_ += 'automationId=' + encodeURIComponent('' + automationId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteWorkflowAutomation(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteWorkflowAutomation(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteWorkflowAutomation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

export class AdminTicketActionListDto implements IAdminTicketActionListDto {
    id: number;
    name: string | undefined;
    ticketType: string | undefined;
    ticketStatus: string | undefined;
    action: string | undefined;

    constructor(data?: IAdminTicketActionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.ticketType = _data['ticketType'];
            this.ticketStatus = _data['ticketStatus'];
            this.action = _data['action'];
        }
    }

    static fromJS(data: any): AdminTicketActionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminTicketActionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['ticketType'] = this.ticketType;
        data['ticketStatus'] = this.ticketStatus;
        data['action'] = this.action;
        return data;
    }

    clone(): AdminTicketActionListDto {
        const json = this.toJSON();
        let result = new AdminTicketActionListDto();
        result.init(json);
        return result;
    }
}

export interface IAdminTicketActionListDto {
    id: number;
    name: string | undefined;
    ticketType: string | undefined;
    ticketStatus: string | undefined;
    action: string | undefined;
}

export class CreateCommissionTicketInput implements ICreateCommissionTicketInput {
    commissionWorkbookId: number;
    providerId: number;
    partnerId: number | undefined;
    subject: string | undefined;
    description: string | undefined;

    constructor(data?: ICreateCommissionTicketInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commissionWorkbookId = _data['commissionWorkbookId'];
            this.providerId = _data['providerId'];
            this.partnerId = _data['partnerId'];
            this.subject = _data['subject'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): CreateCommissionTicketInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommissionTicketInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['commissionWorkbookId'] = this.commissionWorkbookId;
        data['providerId'] = this.providerId;
        data['partnerId'] = this.partnerId;
        data['subject'] = this.subject;
        data['description'] = this.description;
        return data;
    }

    clone(): CreateCommissionTicketInput {
        const json = this.toJSON();
        let result = new CreateCommissionTicketInput();
        result.init(json);
        return result;
    }
}

export interface ICreateCommissionTicketInput {
    commissionWorkbookId: number;
    providerId: number;
    partnerId: number | undefined;
    subject: string | undefined;
    description: string | undefined;
}

export class CreateOrUpdateTicketActionInput implements ICreateOrUpdateTicketActionInput {
    ticketAction: TicketActionAdminEditDto;

    constructor(data?: ICreateOrUpdateTicketActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ticketAction = new TicketActionAdminEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketAction = _data['ticketAction']
                ? TicketActionAdminEditDto.fromJS(_data['ticketAction'])
                : new TicketActionAdminEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateTicketActionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTicketActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketAction'] = this.ticketAction ? this.ticketAction.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTicketActionInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTicketActionInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTicketActionInput {
    ticketAction: TicketActionAdminEditDto;
}

export class CreateOrUpdateTicketInput implements ICreateOrUpdateTicketInput {
    ticket: TicketEditDto;

    constructor(data?: ICreateOrUpdateTicketInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticket = _data['ticket'] ? TicketEditDto.fromJS(_data['ticket']) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateTicketInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTicketInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticket'] = this.ticket ? this.ticket.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTicketInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTicketInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTicketInput {
    ticket: TicketEditDto;
}

export class CreateOrUpdateTicketResolutionAdminInput implements ICreateOrUpdateTicketResolutionAdminInput {
    ticketResolution: TicketResolutionAdminEditDto;

    constructor(data?: ICreateOrUpdateTicketResolutionAdminInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ticketResolution = new TicketResolutionAdminEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketResolution = _data['ticketResolution']
                ? TicketResolutionAdminEditDto.fromJS(_data['ticketResolution'])
                : new TicketResolutionAdminEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateTicketResolutionAdminInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTicketResolutionAdminInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketResolution'] = this.ticketResolution ? this.ticketResolution.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTicketResolutionAdminInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTicketResolutionAdminInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTicketResolutionAdminInput {
    ticketResolution: TicketResolutionAdminEditDto;
}

export class CreateOrUpdateTicketSourceInput implements ICreateOrUpdateTicketSourceInput {
    ticketSource: TicketSourceEditDto;

    constructor(data?: ICreateOrUpdateTicketSourceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ticketSource = new TicketSourceEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketSource = _data['ticketSource'] ? TicketSourceEditDto.fromJS(_data['ticketSource']) : new TicketSourceEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateTicketSourceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTicketSourceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketSource'] = this.ticketSource ? this.ticketSource.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTicketSourceInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTicketSourceInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTicketSourceInput {
    ticketSource: TicketSourceEditDto;
}

export class CreateOrUpdateTicketStatusInput implements ICreateOrUpdateTicketStatusInput {
    ticketStatus: TicketStatusEditDto;

    constructor(data?: ICreateOrUpdateTicketStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ticketStatus = new TicketStatusEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketStatus = _data['ticketStatus'] ? TicketStatusEditDto.fromJS(_data['ticketStatus']) : new TicketStatusEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateTicketStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTicketStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketStatus'] = this.ticketStatus ? this.ticketStatus.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTicketStatusInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTicketStatusInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTicketStatusInput {
    ticketStatus: TicketStatusEditDto;
}

export class CreateOrUpdateTicketTypeInput implements ICreateOrUpdateTicketTypeInput {
    ticketType: TicketTypeAdminEditDto;

    constructor(data?: ICreateOrUpdateTicketTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ticketType = new TicketTypeAdminEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketType = _data['ticketType'] ? TicketTypeAdminEditDto.fromJS(_data['ticketType']) : new TicketTypeAdminEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateTicketTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateTicketTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketType'] = this.ticketType ? this.ticketType.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateOrUpdateTicketTypeInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateTicketTypeInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateTicketTypeInput {
    ticketType: TicketTypeAdminEditDto;
}

export class CreateOrderTicketInput implements ICreateOrderTicketInput {
    orderId: number;
    subject: string | undefined;
    description: string | undefined;
    partnerId: number;
    customerId: number;
    orderInquiryType: OrderInquiryType;
    uniqueProviderIds: number[] | undefined;

    constructor(data?: ICreateOrderTicketInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data['orderId'];
            this.subject = _data['subject'];
            this.description = _data['description'];
            this.partnerId = _data['partnerId'];
            this.customerId = _data['customerId'];
            this.orderInquiryType = _data['orderInquiryType'];
            if (Array.isArray(_data['uniqueProviderIds'])) {
                this.uniqueProviderIds = [] as any;
                for (let item of _data['uniqueProviderIds']) this.uniqueProviderIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrderTicketInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderTicketInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['orderId'] = this.orderId;
        data['subject'] = this.subject;
        data['description'] = this.description;
        data['partnerId'] = this.partnerId;
        data['customerId'] = this.customerId;
        data['orderInquiryType'] = this.orderInquiryType;
        if (Array.isArray(this.uniqueProviderIds)) {
            data['uniqueProviderIds'] = [];
            for (let item of this.uniqueProviderIds) data['uniqueProviderIds'].push(item);
        }
        return data;
    }

    clone(): CreateOrderTicketInput {
        const json = this.toJSON();
        let result = new CreateOrderTicketInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderTicketInput {
    orderId: number;
    subject: string | undefined;
    description: string | undefined;
    partnerId: number;
    customerId: number;
    orderInquiryType: OrderInquiryType;
    uniqueProviderIds: number[] | undefined;
}

export class CreateTicketFromEmailInput implements ICreateTicketFromEmailInput {
    id: string | undefined;
    emailAddress: string | undefined;
    headers: string | undefined;
    ticketType: string | undefined;
    subject: string | undefined;
    description: string | undefined;
    attachmentName: string | undefined;
    attachmentURL: string | undefined;
    attachment: string | undefined;
    received: string | undefined;
    processed: string | undefined;
    quoteid: string | undefined;
    quoteproviderid: string | undefined;
    ticketid: string | undefined;
    orderid: string | undefined;
    toField: string | undefined;
    toFieldCC: string | undefined;
    activityCategory: ActivityCategory;

    constructor(data?: ICreateTicketFromEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.emailAddress = _data['emailAddress'];
            this.headers = _data['headers'];
            this.ticketType = _data['ticketType'];
            this.subject = _data['subject'];
            this.description = _data['description'];
            this.attachmentName = _data['attachmentName'];
            this.attachmentURL = _data['attachmentURL'];
            this.attachment = _data['attachment'];
            this.received = _data['received'];
            this.processed = _data['processed'];
            this.quoteid = _data['quoteid'];
            this.quoteproviderid = _data['quoteproviderid'];
            this.ticketid = _data['ticketid'];
            this.orderid = _data['orderid'];
            this.toField = _data['toField'];
            this.toFieldCC = _data['toFieldCC'];
            this.activityCategory = _data['activityCategory'];
        }
    }

    static fromJS(data: any): CreateTicketFromEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketFromEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['emailAddress'] = this.emailAddress;
        data['headers'] = this.headers;
        data['ticketType'] = this.ticketType;
        data['subject'] = this.subject;
        data['description'] = this.description;
        data['attachmentName'] = this.attachmentName;
        data['attachmentURL'] = this.attachmentURL;
        data['attachment'] = this.attachment;
        data['received'] = this.received;
        data['processed'] = this.processed;
        data['quoteid'] = this.quoteid;
        data['quoteproviderid'] = this.quoteproviderid;
        data['ticketid'] = this.ticketid;
        data['orderid'] = this.orderid;
        data['toField'] = this.toField;
        data['toFieldCC'] = this.toFieldCC;
        data['activityCategory'] = this.activityCategory;
        return data;
    }

    clone(): CreateTicketFromEmailInput {
        const json = this.toJSON();
        let result = new CreateTicketFromEmailInput();
        result.init(json);
        return result;
    }
}

export interface ICreateTicketFromEmailInput {
    id: string | undefined;
    emailAddress: string | undefined;
    headers: string | undefined;
    ticketType: string | undefined;
    subject: string | undefined;
    description: string | undefined;
    attachmentName: string | undefined;
    attachmentURL: string | undefined;
    attachment: string | undefined;
    received: string | undefined;
    processed: string | undefined;
    quoteid: string | undefined;
    quoteproviderid: string | undefined;
    ticketid: string | undefined;
    orderid: string | undefined;
    toField: string | undefined;
    toFieldCC: string | undefined;
    activityCategory: ActivityCategory;
}

export class CreateTicketFromEmailOutput implements ICreateTicketFromEmailOutput {
    ticketId: number | undefined;

    constructor(data?: ICreateTicketFromEmailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
        }
    }

    static fromJS(data: any): CreateTicketFromEmailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTicketFromEmailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        return data;
    }

    clone(): CreateTicketFromEmailOutput {
        const json = this.toJSON();
        let result = new CreateTicketFromEmailOutput();
        result.init(json);
        return result;
    }
}

export interface ICreateTicketFromEmailOutput {
    ticketId: number | undefined;
}

export class Department implements IDepartment {
    tenantId: number | undefined;
    name: string;
    senderAddress: string;
    isKafkaEnabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    ticketWorkflowAutomations: TicketWorkflowAutomation[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.senderAddress = _data['senderAddress'];
            this.isKafkaEnabled = _data['isKafkaEnabled'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['ticketWorkflowAutomations'])) {
                this.ticketWorkflowAutomations = [] as any;
                for (let item of _data['ticketWorkflowAutomations'])
                    this.ticketWorkflowAutomations.push(TicketWorkflowAutomation.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['senderAddress'] = this.senderAddress;
        data['isKafkaEnabled'] = this.isKafkaEnabled;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.ticketWorkflowAutomations)) {
            data['ticketWorkflowAutomations'] = [];
            for (let item of this.ticketWorkflowAutomations) data['ticketWorkflowAutomations'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Department {
        const json = this.toJSON();
        let result = new Department();
        result.init(json);
        return result;
    }
}

export interface IDepartment {
    tenantId: number | undefined;
    name: string;
    senderAddress: string;
    isKafkaEnabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    ticketWorkflowAutomations: TicketWorkflowAutomation[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export interface IDocumentListDto {
    documentName: string | undefined;
    providerId: number;
    documentType: DocumentType;
    key: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum DocumentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export interface IEmailDetailInput {
    from: string | undefined;
    subject: string | undefined;
    mailToList: string[] | undefined;
    mailCcList: string[] | undefined;
    mailBccList: string[] | undefined;
    body: string | undefined;
    documents: DocumentListDto[] | undefined;
    unsubscribeGroup: string | undefined;
    emailType: OnDemandEmailType;
}

export class GetTickeForQuoteAndOrder implements IGetTickeForQuoteAndOrder {
    ticketId: number | undefined;
    ticketNumber: string | undefined;

    constructor(data?: IGetTickeForQuoteAndOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
            this.ticketNumber = _data['ticketNumber'];
        }
    }

    static fromJS(data: any): GetTickeForQuoteAndOrder {
        data = typeof data === 'object' ? data : {};
        let result = new GetTickeForQuoteAndOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        data['ticketNumber'] = this.ticketNumber;
        return data;
    }

    clone(): GetTickeForQuoteAndOrder {
        const json = this.toJSON();
        let result = new GetTickeForQuoteAndOrder();
        result.init(json);
        return result;
    }
}

export interface IGetTickeForQuoteAndOrder {
    ticketId: number | undefined;
    ticketNumber: string | undefined;
}

export class GetTicketForEditOutput implements IGetTicketForEditOutput {
    ticket: TicketEditDto;

    constructor(data?: IGetTicketForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticket = _data['ticket'] ? TicketEditDto.fromJS(_data['ticket']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTicketForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTicketForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticket'] = this.ticket ? this.ticket.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetTicketForEditOutput {
        const json = this.toJSON();
        let result = new GetTicketForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetTicketForEditOutput {
    ticket: TicketEditDto;
}

export class ITicketEmailBodyBuilder implements IITicketEmailBodyBuilder {
    constructor(data?: IITicketEmailBodyBuilder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): ITicketEmailBodyBuilder {
        data = typeof data === 'object' ? data : {};
        let result = new ITicketEmailBodyBuilder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ITicketEmailBodyBuilder {
        const json = this.toJSON();
        let result = new ITicketEmailBodyBuilder();
        result.init(json);
        return result;
    }
}

export interface IITicketEmailBodyBuilder {}

export class LatestTicketNoteOutput implements ILatestTicketNoteOutput {
    creationTime: moment.Moment;
    creatorEmailAddress: string | undefined;
    noteDetail: string | undefined;

    constructor(data?: ILatestTicketNoteOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorEmailAddress = _data['creatorEmailAddress'];
            this.noteDetail = _data['noteDetail'];
        }
    }

    static fromJS(data: any): LatestTicketNoteOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LatestTicketNoteOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorEmailAddress'] = this.creatorEmailAddress;
        data['noteDetail'] = this.noteDetail;
        return data;
    }

    clone(): LatestTicketNoteOutput {
        const json = this.toJSON();
        let result = new LatestTicketNoteOutput();
        result.init(json);
        return result;
    }
}

export interface ILatestTicketNoteOutput {
    creationTime: moment.Moment;
    creatorEmailAddress: string | undefined;
    noteDetail: string | undefined;
}

export class LinkedOrderDto implements ILinkedOrderDto {
    id: number;
    orderNumber: string | undefined;

    constructor(data?: ILinkedOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): LinkedOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        return data;
    }

    clone(): LinkedOrderDto {
        const json = this.toJSON();
        let result = new LinkedOrderDto();
        result.init(json);
        return result;
    }
}

export interface ILinkedOrderDto {
    id: number;
    orderNumber: string | undefined;
}

export class LinkedQuoteDto implements ILinkedQuoteDto {
    id: number;
    quoteNumber: string | undefined;

    constructor(data?: ILinkedQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quoteNumber = _data["quoteNumber"];
        }
    }

    static fromJS(data: any): LinkedQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quoteNumber"] = this.quoteNumber;
        return data;
    }

    clone(): LinkedQuoteDto {
        const json = this.toJSON();
        let result = new LinkedQuoteDto();
        result.init(json);
        return result;
    }
}

export interface ILinkedQuoteDto {
    id: number;
    quoteNumber: string | undefined;
}

export class MergeTicketInput implements IMergeTicketInput {
    sourceTicketId: number;
    targetTicketId: number;
    sourceTicketResolutionId: number;

    constructor(data?: IMergeTicketInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceTicketId = _data['sourceTicketId'];
            this.targetTicketId = _data['targetTicketId'];
            this.sourceTicketResolutionId = _data['sourceTicketResolutionId'];
        }
    }

    static fromJS(data: any): MergeTicketInput {
        data = typeof data === 'object' ? data : {};
        let result = new MergeTicketInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['sourceTicketId'] = this.sourceTicketId;
        data['targetTicketId'] = this.targetTicketId;
        data['sourceTicketResolutionId'] = this.sourceTicketResolutionId;
        return data;
    }

    clone(): MergeTicketInput {
        const json = this.toJSON();
        let result = new MergeTicketInput();
        result.init(json);
        return result;
    }
}

export interface IMergeTicketInput {
    sourceTicketId: number;
    targetTicketId: number;
    sourceTicketResolutionId: number;
}

export enum OrderInquiryType {
    _1 = 1,
    _2 = 2,
}

export class SurveyDto implements ISurveyDto {
    id: number;
    name: string;
    template: string;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    isEnabled: boolean;
    mappedTicketNotificationIds: number[] | undefined;
    mappedMilestoneIds: number[] | undefined;
    mappedOnDemandEmailIds: OnDemandEmailType[] | undefined;

    constructor(data?: ISurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.template = _data['template'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.isEnabled = _data['isEnabled'];
            if (Array.isArray(_data['mappedTicketNotificationIds'])) {
                this.mappedTicketNotificationIds = [] as any;
                for (let item of _data['mappedTicketNotificationIds']) this.mappedTicketNotificationIds.push(item);
            }
            if (Array.isArray(_data['mappedMilestoneIds'])) {
                this.mappedMilestoneIds = [] as any;
                for (let item of _data['mappedMilestoneIds']) this.mappedMilestoneIds.push(item);
            }
            if (Array.isArray(_data['mappedOnDemandEmailIds'])) {
                this.mappedOnDemandEmailIds = [] as any;
                for (let item of _data['mappedOnDemandEmailIds']) this.mappedOnDemandEmailIds.push(item);
            }
        }
    }

    static fromJS(data: any): SurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['template'] = this.template;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['isEnabled'] = this.isEnabled;
        if (Array.isArray(this.mappedTicketNotificationIds)) {
            data['mappedTicketNotificationIds'] = [];
            for (let item of this.mappedTicketNotificationIds) data['mappedTicketNotificationIds'].push(item);
        }
        if (Array.isArray(this.mappedMilestoneIds)) {
            data['mappedMilestoneIds'] = [];
            for (let item of this.mappedMilestoneIds) data['mappedMilestoneIds'].push(item);
        }
        if (Array.isArray(this.mappedOnDemandEmailIds)) {
            data['mappedOnDemandEmailIds'] = [];
            for (let item of this.mappedOnDemandEmailIds) data['mappedOnDemandEmailIds'].push(item);
        }
        return data;
    }

    clone(): SurveyDto {
        const json = this.toJSON();
        let result = new SurveyDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyDto {
    id: number;
    name: string;
    template: string;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    isEnabled: boolean;
    mappedTicketNotificationIds: number[] | undefined;
    mappedMilestoneIds: number[] | undefined;
    mappedOnDemandEmailIds: OnDemandEmailType[] | undefined;
}

export class TicketAccountForCustomerDto implements ITicketAccountForCustomerDto {
    ticketId: number;
    ticketAccountTypeId: TicketAccountType;
    account: number;
    customerDetail: CustomerListDto;
    id: number;

    constructor(data?: ITicketAccountForCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
            this.ticketAccountTypeId = _data['ticketAccountTypeId'];
            this.account = _data['account'];
            this.customerDetail = _data['customerDetail'] ? CustomerListDto.fromJS(_data['customerDetail']) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketAccountForCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAccountForCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        data['ticketAccountTypeId'] = this.ticketAccountTypeId;
        data['account'] = this.account;
        data['customerDetail'] = this.customerDetail ? this.customerDetail.toJSON() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketAccountForCustomerDto {
        const json = this.toJSON();
        let result = new TicketAccountForCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ITicketAccountForCustomerDto {
    ticketId: number;
    ticketAccountTypeId: TicketAccountType;
    account: number;
    customerDetail: CustomerListDto;
    id: number;
}

export class TicketAccountForLocationDto implements ITicketAccountForLocationDto {
    ticketId: number;
    ticketAccountTypeId: TicketAccountType;
    account: number;
    locationDetail: CustomerLocationDto;
    id: number;

    constructor(data?: ITicketAccountForLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
            this.ticketAccountTypeId = _data['ticketAccountTypeId'];
            this.account = _data['account'];
            this.locationDetail = _data['locationDetail'] ? CustomerLocationDto.fromJS(_data['locationDetail']) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketAccountForLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAccountForLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        data['ticketAccountTypeId'] = this.ticketAccountTypeId;
        data['account'] = this.account;
        data['locationDetail'] = this.locationDetail ? this.locationDetail.toJSON() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketAccountForLocationDto {
        const json = this.toJSON();
        let result = new TicketAccountForLocationDto();
        result.init(json);
        return result;
    }
}

export interface ITicketAccountForLocationDto {
    ticketId: number;
    ticketAccountTypeId: TicketAccountType;
    account: number;
    locationDetail: CustomerLocationDto;
    id: number;
}

export class TicketAccountForProductDto implements ITicketAccountForProductDto {
    ticketId: number;
    ticketAccountTypeId: TicketAccountType;
    account: number;
    productDetail: ProductListDto;
    id: number;

    constructor(data?: ITicketAccountForProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
            this.ticketAccountTypeId = _data['ticketAccountTypeId'];
            this.account = _data['account'];
            this.productDetail = _data['productDetail'] ? ProductListDto.fromJS(_data['productDetail']) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketAccountForProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAccountForProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        data['ticketAccountTypeId'] = this.ticketAccountTypeId;
        data['account'] = this.account;
        data['productDetail'] = this.productDetail ? this.productDetail.toJSON() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketAccountForProductDto {
        const json = this.toJSON();
        let result = new TicketAccountForProductDto();
        result.init(json);
        return result;
    }
}

export interface ITicketAccountForProductDto {
    ticketId: number;
    ticketAccountTypeId: TicketAccountType;
    account: number;
    productDetail: ProductListDto;
    id: number;
}

export class TicketAccountForProviderDto implements ITicketAccountForProviderDto {
    ticketId: number;
    ticketAccountTypeId: TicketAccountType;
    account: number;
    providerDetail: ProviderListDto;
    id: number;

    constructor(data?: ITicketAccountForProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
            this.ticketAccountTypeId = _data['ticketAccountTypeId'];
            this.account = _data['account'];
            this.providerDetail = _data['providerDetail'] ? ProviderListDto.fromJS(_data['providerDetail']) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketAccountForProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAccountForProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        data['ticketAccountTypeId'] = this.ticketAccountTypeId;
        data['account'] = this.account;
        data['providerDetail'] = this.providerDetail ? this.providerDetail.toJSON() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketAccountForProviderDto {
        const json = this.toJSON();
        let result = new TicketAccountForProviderDto();
        result.init(json);
        return result;
    }
}

export interface ITicketAccountForProviderDto {
    ticketId: number;
    ticketAccountTypeId: TicketAccountType;
    account: number;
    providerDetail: ProviderListDto;
    id: number;
}

export enum TicketAccountType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class TicketActionAdminEditDto implements ITicketActionAdminEditDto {
    tenantId: number | undefined;
    name: string;
    ticketTypeId: number;
    ticketStatusId: number;
    actionId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketActionAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.ticketTypeId = _data['ticketTypeId'];
            this.ticketStatusId = _data['ticketStatusId'];
            this.actionId = _data['actionId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketActionAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketActionAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['ticketTypeId'] = this.ticketTypeId;
        data['ticketStatusId'] = this.ticketStatusId;
        data['actionId'] = this.actionId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketActionAdminEditDto {
        const json = this.toJSON();
        let result = new TicketActionAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketActionAdminEditDto {
    tenantId: number | undefined;
    name: string;
    ticketTypeId: number;
    ticketStatusId: number;
    actionId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketDepartmentInput implements ITicketDepartmentInput {
    ticketId: number;
    departmentId: number | undefined;
    statusId: number | undefined;
    typeId: number | undefined;
    resolutionId: number | undefined;
    assignedUserId: number | undefined;

    constructor(data?: ITicketDepartmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
            this.departmentId = _data['departmentId'];
            this.statusId = _data['statusId'];
            this.typeId = _data['typeId'];
            this.resolutionId = _data['resolutionId'];
            this.assignedUserId = _data['assignedUserId'];
        }
    }

    static fromJS(data: any): TicketDepartmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDepartmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        data['departmentId'] = this.departmentId;
        data['statusId'] = this.statusId;
        data['typeId'] = this.typeId;
        data['resolutionId'] = this.resolutionId;
        data['assignedUserId'] = this.assignedUserId;
        return data;
    }

    clone(): TicketDepartmentInput {
        const json = this.toJSON();
        let result = new TicketDepartmentInput();
        result.init(json);
        return result;
    }
}

export interface ITicketDepartmentInput {
    ticketId: number;
    departmentId: number | undefined;
    statusId: number | undefined;
    typeId: number | undefined;
    resolutionId: number | undefined;
    assignedUserId: number | undefined;
}

export class TicketEditDto implements ITicketEditDto {
    tenantId: number | undefined;
    requestorId: number | undefined;
    requestorName: string | undefined;
    requestorEmail: string | undefined;
    requestorPhone: string | undefined;
    requestor: UserListDto;
    ticketNumber: string | undefined;
    providerTicketNumber: string | undefined;
    description: string | undefined;
    ticketPriority: TicketPriority;
    ticketStatusId: number | undefined;
    ticketStatus: string | undefined;
    ticketResolutionId: number | undefined;
    ticketResolution: TicketResolutionEditDto;
    ticketTypeId: number | undefined;
    ticketType: TicketTypeEditDto;
    assignedUserId: number | undefined;
    assignedUserName: string | undefined;
    departmentId: number | undefined;
    departmentName: string | undefined;
    departmentSenderAddress: string | undefined;
    ticketSourceId: number;
    ticketSource: string | undefined;
    partnerId: number | undefined;
    partnerName: string | undefined;
    customerId: number | undefined;
    company: TicketAccountForCustomerDto;
    locationId: number | undefined;
    location: TicketAccountForLocationDto;
    productId: number | undefined;
    product: TicketAccountForProductDto;
    providerIds: number[] | undefined;
    providerNames: string[] | undefined;
    providers: TicketAccountForProviderDto[] | undefined;
    subject: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    emailAddress: string | undefined;
    attachment: string | undefined;
    messageId: string | undefined;
    linkedQuotes: LinkedQuoteDto[] | undefined;
    linkedOrders: LinkedOrderDto[] | undefined;
    id: number;

    constructor(data?: ITicketEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.requestorId = _data['requestorId'];
            this.requestorName = _data['requestorName'];
            this.requestorEmail = _data['requestorEmail'];
            this.requestorPhone = _data['requestorPhone'];
            this.requestor = _data['requestor'] ? UserListDto.fromJS(_data['requestor']) : <any>undefined;
            this.ticketNumber = _data['ticketNumber'];
            this.providerTicketNumber = _data['providerTicketNumber'];
            this.description = _data['description'];
            this.ticketPriority = _data['ticketPriority'];
            this.ticketStatusId = _data['ticketStatusId'];
            this.ticketStatus = _data['ticketStatus'];
            this.ticketResolutionId = _data['ticketResolutionId'];
            this.ticketResolution = _data['ticketResolution'] ? TicketResolutionEditDto.fromJS(_data['ticketResolution']) : <any>undefined;
            this.ticketTypeId = _data['ticketTypeId'];
            this.ticketType = _data['ticketType'] ? TicketTypeEditDto.fromJS(_data['ticketType']) : <any>undefined;
            this.assignedUserId = _data['assignedUserId'];
            this.assignedUserName = _data['assignedUserName'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
            this.departmentSenderAddress = _data['departmentSenderAddress'];
            this.ticketSourceId = _data['ticketSourceId'];
            this.ticketSource = _data['ticketSource'];
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.customerId = _data['customerId'];
            this.company = _data['company'] ? TicketAccountForCustomerDto.fromJS(_data['company']) : <any>undefined;
            this.locationId = _data['locationId'];
            this.location = _data['location'] ? TicketAccountForLocationDto.fromJS(_data['location']) : <any>undefined;
            this.productId = _data['productId'];
            this.product = _data['product'] ? TicketAccountForProductDto.fromJS(_data['product']) : <any>undefined;
            if (Array.isArray(_data['providerIds'])) {
                this.providerIds = [] as any;
                for (let item of _data['providerIds']) this.providerIds.push(item);
            }
            if (Array.isArray(_data['providerNames'])) {
                this.providerNames = [] as any;
                for (let item of _data['providerNames']) this.providerNames.push(item);
            }
            if (Array.isArray(_data['providers'])) {
                this.providers = [] as any;
                for (let item of _data['providers']) this.providers.push(TicketAccountForProviderDto.fromJS(item));
            }
            this.subject = _data["subject"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.attachment = _data["attachment"];
            this.messageId = _data["messageId"];
            if (Array.isArray(_data["linkedQuotes"])) {
                this.linkedQuotes = [] as any;
                for (let item of _data["linkedQuotes"])
                    this.linkedQuotes.push(LinkedQuoteDto.fromJS(item));
            }
            if (Array.isArray(_data["linkedOrders"])) {
                this.linkedOrders = [] as any;
                for (let item of _data["linkedOrders"])
                    this.linkedOrders.push(LinkedOrderDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TicketEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['requestorId'] = this.requestorId;
        data['requestorName'] = this.requestorName;
        data['requestorEmail'] = this.requestorEmail;
        data['requestorPhone'] = this.requestorPhone;
        data['requestor'] = this.requestor ? this.requestor.toJSON() : <any>undefined;
        data['ticketNumber'] = this.ticketNumber;
        data['providerTicketNumber'] = this.providerTicketNumber;
        data['description'] = this.description;
        data['ticketPriority'] = this.ticketPriority;
        data['ticketStatusId'] = this.ticketStatusId;
        data['ticketStatus'] = this.ticketStatus;
        data['ticketResolutionId'] = this.ticketResolutionId;
        data['ticketResolution'] = this.ticketResolution ? this.ticketResolution.toJSON() : <any>undefined;
        data['ticketTypeId'] = this.ticketTypeId;
        data['ticketType'] = this.ticketType ? this.ticketType.toJSON() : <any>undefined;
        data['assignedUserId'] = this.assignedUserId;
        data['assignedUserName'] = this.assignedUserName;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        data['departmentSenderAddress'] = this.departmentSenderAddress;
        data['ticketSourceId'] = this.ticketSourceId;
        data['ticketSource'] = this.ticketSource;
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['customerId'] = this.customerId;
        data['company'] = this.company ? this.company.toJSON() : <any>undefined;
        data['locationId'] = this.locationId;
        data['location'] = this.location ? this.location.toJSON() : <any>undefined;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.providerIds)) {
            data['providerIds'] = [];
            for (let item of this.providerIds) data['providerIds'].push(item);
        }
        if (Array.isArray(this.providerNames)) {
            data['providerNames'] = [];
            for (let item of this.providerNames) data['providerNames'].push(item);
        }
        if (Array.isArray(this.providers)) {
            data['providers'] = [];
            for (let item of this.providers) data['providers'].push(item.toJSON());
        }
        data["subject"] = this.subject;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["attachment"] = this.attachment;
        data["messageId"] = this.messageId;
        if (Array.isArray(this.linkedQuotes)) {
            data["linkedQuotes"] = [];
            for (let item of this.linkedQuotes)
                data["linkedQuotes"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedOrders)) {
            data["linkedOrders"] = [];
            for (let item of this.linkedOrders)
                data["linkedOrders"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): TicketEditDto {
        const json = this.toJSON();
        let result = new TicketEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketEditDto {
    tenantId: number | undefined;
    requestorId: number | undefined;
    requestorName: string | undefined;
    requestorEmail: string | undefined;
    requestorPhone: string | undefined;
    requestor: UserListDto;
    ticketNumber: string | undefined;
    providerTicketNumber: string | undefined;
    description: string | undefined;
    ticketPriority: TicketPriority;
    ticketStatusId: number | undefined;
    ticketStatus: string | undefined;
    ticketResolutionId: number | undefined;
    ticketResolution: TicketResolutionEditDto;
    ticketTypeId: number | undefined;
    ticketType: TicketTypeEditDto;
    assignedUserId: number | undefined;
    assignedUserName: string | undefined;
    departmentId: number | undefined;
    departmentName: string | undefined;
    departmentSenderAddress: string | undefined;
    ticketSourceId: number;
    ticketSource: string | undefined;
    partnerId: number | undefined;
    partnerName: string | undefined;
    customerId: number | undefined;
    company: TicketAccountForCustomerDto;
    locationId: number | undefined;
    location: TicketAccountForLocationDto;
    productId: number | undefined;
    product: TicketAccountForProductDto;
    providerIds: number[] | undefined;
    providerNames: string[] | undefined;
    providers: TicketAccountForProviderDto[] | undefined;
    subject: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    emailAddress: string | undefined;
    attachment: string | undefined;
    messageId: string | undefined;
    linkedQuotes: LinkedQuoteDto[] | undefined;
    linkedOrders: LinkedOrderDto[] | undefined;
    id: number;
}

export class TicketEmailTemplateOutput implements ITicketEmailTemplateOutput {
    emailTemplate: string | undefined;

    constructor(data?: ITicketEmailTemplateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplate = _data['emailTemplate'];
        }
    }

    static fromJS(data: any): TicketEmailTemplateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TicketEmailTemplateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailTemplate'] = this.emailTemplate;
        return data;
    }

    clone(): TicketEmailTemplateOutput {
        const json = this.toJSON();
        let result = new TicketEmailTemplateOutput();
        result.init(json);
        return result;
    }
}

export interface ITicketEmailTemplateOutput {
    emailTemplate: string | undefined;
}

export class TicketListDto implements ITicketListDto {
    ticketNumber: string | undefined;
    description: string | undefined;
    ticketTypeName: string | undefined;
    ticketStatusName: string | undefined;
    requestorName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketNumber = _data['ticketNumber'];
            this.description = _data['description'];
            this.ticketTypeName = _data['ticketTypeName'];
            this.ticketStatusName = _data['ticketStatusName'];
            this.requestorName = _data['requestorName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketNumber'] = this.ticketNumber;
        data['description'] = this.description;
        data['ticketTypeName'] = this.ticketTypeName;
        data['ticketStatusName'] = this.ticketStatusName;
        data['requestorName'] = this.requestorName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketListDto {
        const json = this.toJSON();
        let result = new TicketListDto();
        result.init(json);
        return result;
    }
}

export interface ITicketListDto {
    ticketNumber: string | undefined;
    description: string | undefined;
    ticketTypeName: string | undefined;
    ticketStatusName: string | undefined;
    requestorName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketListOutput implements ITicketListOutput {
    ticketId: number;
    ticketStatusId: number | undefined;
    ticketStatusName: string | undefined;
    ticketTypeId: number | undefined;
    ticketTypeName: string | undefined;
    departmentId: number | undefined;
    departmentName: string | undefined;
    subject: string | undefined;
    createdOn: moment.Moment | undefined;
    ticketNumber: string | undefined;
    ticketPriority: string | undefined;
    providerTicketNumber: string | undefined;
    requestorId: number | undefined;
    requestorName: string | undefined;
    assignedUserId: number | undefined;
    assignedUserName: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    locationId: number | undefined;
    locationName: string | undefined;
    providerNames: string | undefined;
    partnerId: number | undefined;
    apid: number | undefined;
    partnerName: string | undefined;
    advisorEntitlementId: number | undefined;
    accountManagerId: number | undefined;
    accountManagerName: string | undefined;

    constructor(data?: ITicketListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data['ticketId'];
            this.ticketStatusId = _data['ticketStatusId'];
            this.ticketStatusName = _data['ticketStatusName'];
            this.ticketTypeId = _data['ticketTypeId'];
            this.ticketTypeName = _data['ticketTypeName'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
            this.subject = _data['subject'];
            this.createdOn = _data['createdOn'] ? moment(_data['createdOn'].toString()) : <any>undefined;
            this.ticketNumber = _data['ticketNumber'];
            this.ticketPriority = _data['ticketPriority'];
            this.providerTicketNumber = _data['providerTicketNumber'];
            this.requestorId = _data['requestorId'];
            this.requestorName = _data['requestorName'];
            this.assignedUserId = _data['assignedUserId'];
            this.assignedUserName = _data['assignedUserName'];
            this.customerId = _data['customerId'];
            this.customerName = _data['customerName'];
            this.locationId = _data['locationId'];
            this.locationName = _data['locationName'];
            this.providerNames = _data['providerNames'];
            this.partnerId = _data['partnerId'];
            this.apid = _data['apid'];
            this.partnerName = _data['partnerName'];
            this.advisorEntitlementId = _data['advisorEntitlementId'];
            this.accountManagerId = _data['accountManagerId'];
            this.accountManagerName = _data['accountManagerName'];
        }
    }

    static fromJS(data: any): TicketListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TicketListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketId'] = this.ticketId;
        data['ticketStatusId'] = this.ticketStatusId;
        data['ticketStatusName'] = this.ticketStatusName;
        data['ticketTypeId'] = this.ticketTypeId;
        data['ticketTypeName'] = this.ticketTypeName;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        data['subject'] = this.subject;
        data['createdOn'] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data['ticketNumber'] = this.ticketNumber;
        data['ticketPriority'] = this.ticketPriority;
        data['providerTicketNumber'] = this.providerTicketNumber;
        data['requestorId'] = this.requestorId;
        data['requestorName'] = this.requestorName;
        data['assignedUserId'] = this.assignedUserId;
        data['assignedUserName'] = this.assignedUserName;
        data['customerId'] = this.customerId;
        data['customerName'] = this.customerName;
        data['locationId'] = this.locationId;
        data['locationName'] = this.locationName;
        data['providerNames'] = this.providerNames;
        data['partnerId'] = this.partnerId;
        data['apid'] = this.apid;
        data['partnerName'] = this.partnerName;
        data['advisorEntitlementId'] = this.advisorEntitlementId;
        data['accountManagerId'] = this.accountManagerId;
        data['accountManagerName'] = this.accountManagerName;
        return data;
    }

    clone(): TicketListOutput {
        const json = this.toJSON();
        let result = new TicketListOutput();
        result.init(json);
        return result;
    }
}

export interface ITicketListOutput {
    ticketId: number;
    ticketStatusId: number | undefined;
    ticketStatusName: string | undefined;
    ticketTypeId: number | undefined;
    ticketTypeName: string | undefined;
    departmentId: number | undefined;
    departmentName: string | undefined;
    subject: string | undefined;
    createdOn: moment.Moment | undefined;
    ticketNumber: string | undefined;
    ticketPriority: string | undefined;
    providerTicketNumber: string | undefined;
    requestorId: number | undefined;
    requestorName: string | undefined;
    assignedUserId: number | undefined;
    assignedUserName: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    locationId: number | undefined;
    locationName: string | undefined;
    providerNames: string | undefined;
    partnerId: number | undefined;
    apid: number | undefined;
    partnerName: string | undefined;
    advisorEntitlementId: number | undefined;
    accountManagerId: number | undefined;
    accountManagerName: string | undefined;
}

export class TicketListOutputPagedResultDto implements ITicketListOutputPagedResultDto {
    totalCount: number;
    items: TicketListOutput[] | undefined;

    constructor(data?: ITicketListOutputPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(TicketListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketListOutputPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketListOutputPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): TicketListOutputPagedResultDto {
        const json = this.toJSON();
        let result = new TicketListOutputPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITicketListOutputPagedResultDto {
    totalCount: number;
    items: TicketListOutput[] | undefined;
}

export class TicketNotificationDto implements ITicketNotificationDto {
    ticketTypeId: number;
    ticketTypeName: string | undefined;
    ticketStatusId: number;
    ticketStatusName: string | undefined;
    enableNotify: boolean;
    notifyProvider: boolean;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    survey: SurveyDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketTypeId = _data['ticketTypeId'];
            this.ticketTypeName = _data['ticketTypeName'];
            this.ticketStatusId = _data['ticketStatusId'];
            this.ticketStatusName = _data['ticketStatusName'];
            this.enableNotify = _data['enableNotify'];
            this.notifyProvider = _data['notifyProvider'];
            this.notifyFrom = _data['notifyFrom'];
            this.notifySubject = _data['notifySubject'];
            this.notifyTemplate = _data['notifyTemplate'];
            this.survey = _data['survey'] ? SurveyDto.fromJS(_data['survey']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketTypeId'] = this.ticketTypeId;
        data['ticketTypeName'] = this.ticketTypeName;
        data['ticketStatusId'] = this.ticketStatusId;
        data['ticketStatusName'] = this.ticketStatusName;
        data['enableNotify'] = this.enableNotify;
        data['notifyProvider'] = this.notifyProvider;
        data['notifyFrom'] = this.notifyFrom;
        data['notifySubject'] = this.notifySubject;
        data['notifyTemplate'] = this.notifyTemplate;
        data['survey'] = this.survey ? this.survey.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketNotificationDto {
        const json = this.toJSON();
        let result = new TicketNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ITicketNotificationDto {
    ticketTypeId: number;
    ticketTypeName: string | undefined;
    ticketStatusId: number;
    ticketStatusName: string | undefined;
    enableNotify: boolean;
    notifyProvider: boolean;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    survey: SurveyDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketNotificationEditDto implements ITicketNotificationEditDto {
    ticketTypeId: number;
    ticketStatusId: number;
    enableNotify: boolean;
    notifyProvider: boolean;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    surveyId: number | undefined;
    id: number | undefined;

    constructor(data?: ITicketNotificationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketTypeId = _data['ticketTypeId'];
            this.ticketStatusId = _data['ticketStatusId'];
            this.enableNotify = _data['enableNotify'];
            this.notifyProvider = _data['notifyProvider'];
            this.notifyFrom = _data['notifyFrom'];
            this.notifySubject = _data['notifySubject'];
            this.notifyTemplate = _data['notifyTemplate'];
            this.surveyId = _data['surveyId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketNotificationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketNotificationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketTypeId'] = this.ticketTypeId;
        data['ticketStatusId'] = this.ticketStatusId;
        data['enableNotify'] = this.enableNotify;
        data['notifyProvider'] = this.notifyProvider;
        data['notifyFrom'] = this.notifyFrom;
        data['notifySubject'] = this.notifySubject;
        data['notifyTemplate'] = this.notifyTemplate;
        data['surveyId'] = this.surveyId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketNotificationEditDto {
        const json = this.toJSON();
        let result = new TicketNotificationEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketNotificationEditDto {
    ticketTypeId: number;
    ticketStatusId: number;
    enableNotify: boolean;
    notifyProvider: boolean;
    notifyFrom: string | undefined;
    notifySubject: string | undefined;
    notifyTemplate: string | undefined;
    surveyId: number | undefined;
    id: number | undefined;
}

export enum TicketPriority {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TicketRequestorDropdownDto implements ITicketRequestorDropdownDto {
    id: number;
    name: string | undefined;
    isPartner: boolean;

    constructor(data?: ITicketRequestorDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.isPartner = _data['isPartner'];
        }
    }

    static fromJS(data: any): TicketRequestorDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketRequestorDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['isPartner'] = this.isPartner;
        return data;
    }

    clone(): TicketRequestorDropdownDto {
        const json = this.toJSON();
        let result = new TicketRequestorDropdownDto();
        result.init(json);
        return result;
    }
}

export interface ITicketRequestorDropdownDto {
    id: number;
    name: string | undefined;
    isPartner: boolean;
}

export class TicketRequestorUserOutput implements ITicketRequestorUserOutput {
    displayText: string | undefined;
    requestorUserId: number | undefined;
    requestorEmail: string | undefined;

    constructor(data?: ITicketRequestorUserOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayText = _data['displayText'];
            this.requestorUserId = _data['requestorUserId'];
            this.requestorEmail = _data['requestorEmail'];
        }
    }

    static fromJS(data: any): TicketRequestorUserOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TicketRequestorUserOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['displayText'] = this.displayText;
        data['requestorUserId'] = this.requestorUserId;
        data['requestorEmail'] = this.requestorEmail;
        return data;
    }

    clone(): TicketRequestorUserOutput {
        const json = this.toJSON();
        let result = new TicketRequestorUserOutput();
        result.init(json);
        return result;
    }
}

export interface ITicketRequestorUserOutput {
    displayText: string | undefined;
    requestorUserId: number | undefined;
    requestorEmail: string | undefined;
}

export class TicketResolutionAdminEditDto implements ITicketResolutionAdminEditDto {
    name: string | undefined;
    departmentId: number;
    department: Department;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketResolutionAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.departmentId = _data['departmentId'];
            this.department = _data['department'] ? Department.fromJS(_data['department']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketResolutionAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketResolutionAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['departmentId'] = this.departmentId;
        data['department'] = this.department ? this.department.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketResolutionAdminEditDto {
        const json = this.toJSON();
        let result = new TicketResolutionAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketResolutionAdminEditDto {
    name: string | undefined;
    departmentId: number;
    department: Department;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketResolutionAdminListDto implements ITicketResolutionAdminListDto {
    name: string | undefined;
    departmentId: number;
    departmentName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketResolutionAdminListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketResolutionAdminListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketResolutionAdminListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketResolutionAdminListDto {
        const json = this.toJSON();
        let result = new TicketResolutionAdminListDto();
        result.init(json);
        return result;
    }
}

export interface ITicketResolutionAdminListDto {
    name: string | undefined;
    departmentId: number;
    departmentName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketResolutionEditDto implements ITicketResolutionEditDto {
    id: number;
    name: string;

    constructor(data?: ITicketResolutionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): TicketResolutionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketResolutionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): TicketResolutionEditDto {
        const json = this.toJSON();
        let result = new TicketResolutionEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketResolutionEditDto {
    id: number;
    name: string;
}

export class TicketResolutionListDto implements ITicketResolutionListDto {
    name: string | undefined;
    departmentName: string | undefined;
    id: number;

    constructor(data?: ITicketResolutionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.departmentName = _data['departmentName'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketResolutionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketResolutionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['departmentName'] = this.departmentName;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketResolutionListDto {
        const json = this.toJSON();
        let result = new TicketResolutionListDto();
        result.init(json);
        return result;
    }
}

export interface ITicketResolutionListDto {
    name: string | undefined;
    departmentName: string | undefined;
    id: number;
}

export class TicketSource implements ITicketSource {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketSource {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketSource {
        const json = this.toJSON();
        let result = new TicketSource();
        result.init(json);
        return result;
    }
}

export interface ITicketSource {
    tenantId: number | undefined;
    name: string;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketSourceDropdownDto implements ITicketSourceDropdownDto {
    id: number;
    name: string | undefined;

    constructor(data?: ITicketSourceDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): TicketSourceDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSourceDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): TicketSourceDropdownDto {
        const json = this.toJSON();
        let result = new TicketSourceDropdownDto();
        result.init(json);
        return result;
    }
}

export interface ITicketSourceDropdownDto {
    id: number;
    name: string | undefined;
}

export class TicketSourceEditDto implements ITicketSourceEditDto {
    tenantId: number | undefined;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketSourceEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketSourceEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSourceEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketSourceEditDto {
        const json = this.toJSON();
        let result = new TicketSourceEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketSourceEditDto {
    tenantId: number | undefined;
    name: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketSourceListDto implements ITicketSourceListDto {
    id: number;
    name: string;

    constructor(data?: ITicketSourceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): TicketSourceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSourceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): TicketSourceListDto {
        const json = this.toJSON();
        let result = new TicketSourceListDto();
        result.init(json);
        return result;
    }
}

export interface ITicketSourceListDto {
    id: number;
    name: string;
}

export class TicketStatus implements ITicketStatus {
    tenantId: number | undefined;
    name: string;
    departmentId: number;
    department: Department;
    readonly departmentName: string | undefined;
    inProgress: boolean;
    isDefault: boolean;
    ticketWorkflowAutomationCurrentStatuses: TicketWorkflowAutomation[] | undefined;
    ticketWorkflowAutomationNewStatuses: TicketWorkflowAutomation[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.departmentId = _data['departmentId'];
            this.department = _data['department'] ? Department.fromJS(_data['department']) : <any>undefined;
            (<any>this).departmentName = _data['departmentName'];
            this.inProgress = _data['inProgress'];
            this.isDefault = _data['isDefault'];
            if (Array.isArray(_data['ticketWorkflowAutomationCurrentStatuses'])) {
                this.ticketWorkflowAutomationCurrentStatuses = [] as any;
                for (let item of _data['ticketWorkflowAutomationCurrentStatuses'])
                    this.ticketWorkflowAutomationCurrentStatuses.push(TicketWorkflowAutomation.fromJS(item));
            }
            if (Array.isArray(_data['ticketWorkflowAutomationNewStatuses'])) {
                this.ticketWorkflowAutomationNewStatuses = [] as any;
                for (let item of _data['ticketWorkflowAutomationNewStatuses'])
                    this.ticketWorkflowAutomationNewStatuses.push(TicketWorkflowAutomation.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TicketStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['departmentId'] = this.departmentId;
        data['department'] = this.department ? this.department.toJSON() : <any>undefined;
        data['departmentName'] = this.departmentName;
        data['inProgress'] = this.inProgress;
        data['isDefault'] = this.isDefault;
        if (Array.isArray(this.ticketWorkflowAutomationCurrentStatuses)) {
            data['ticketWorkflowAutomationCurrentStatuses'] = [];
            for (let item of this.ticketWorkflowAutomationCurrentStatuses)
                data['ticketWorkflowAutomationCurrentStatuses'].push(item.toJSON());
        }
        if (Array.isArray(this.ticketWorkflowAutomationNewStatuses)) {
            data['ticketWorkflowAutomationNewStatuses'] = [];
            for (let item of this.ticketWorkflowAutomationNewStatuses) data['ticketWorkflowAutomationNewStatuses'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketStatus {
        const json = this.toJSON();
        let result = new TicketStatus();
        result.init(json);
        return result;
    }
}

export interface ITicketStatus {
    tenantId: number | undefined;
    name: string;
    departmentId: number;
    department: Department;
    departmentName: string | undefined;
    inProgress: boolean;
    isDefault: boolean;
    ticketWorkflowAutomationCurrentStatuses: TicketWorkflowAutomation[] | undefined;
    ticketWorkflowAutomationNewStatuses: TicketWorkflowAutomation[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketStatusDashboardOutput implements ITicketStatusDashboardOutput {
    ticketStatusId: number | undefined;
    ticketTypeId: number | undefined;
    userId: number | undefined;
    departmentId: number | undefined;
    userFullName: string | undefined;
    ticketTypeName: string | undefined;
    ticketStatusName: string | undefined;
    providerId: number | undefined;
    rowLabel: string | undefined;
    indent: number;
    one: number | undefined;
    three: number | undefined;
    five: number | undefined;
    ten: number | undefined;
    twenty: number | undefined;
    sixty: number | undefined;
    sixtyOnePlus: number | undefined;
    dataId: string;
    parentDataId: string | undefined;
    isCollapsable: boolean;
    areCellsClickable: boolean;

    constructor(data?: ITicketStatusDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketStatusId = _data['ticketStatusId'];
            this.ticketTypeId = _data['ticketTypeId'];
            this.userId = _data['userId'];
            this.departmentId = _data['departmentId'];
            this.userFullName = _data['userFullName'];
            this.ticketTypeName = _data['ticketTypeName'];
            this.ticketStatusName = _data['ticketStatusName'];
            this.providerId = _data['providerId'];
            this.rowLabel = _data['rowLabel'];
            this.indent = _data['indent'];
            this.one = _data['one'];
            this.three = _data['three'];
            this.five = _data['five'];
            this.ten = _data['ten'];
            this.twenty = _data['twenty'];
            this.sixty = _data['sixty'];
            this.sixtyOnePlus = _data['sixtyOnePlus'];
            this.dataId = _data['dataId'];
            this.parentDataId = _data['parentDataId'];
            this.isCollapsable = _data['isCollapsable'];
            this.areCellsClickable = _data['areCellsClickable'];
        }
    }

    static fromJS(data: any): TicketStatusDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TicketStatusDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['ticketStatusId'] = this.ticketStatusId;
        data['ticketTypeId'] = this.ticketTypeId;
        data['userId'] = this.userId;
        data['departmentId'] = this.departmentId;
        data['userFullName'] = this.userFullName;
        data['ticketTypeName'] = this.ticketTypeName;
        data['ticketStatusName'] = this.ticketStatusName;
        data['providerId'] = this.providerId;
        data['rowLabel'] = this.rowLabel;
        data['indent'] = this.indent;
        data['one'] = this.one;
        data['three'] = this.three;
        data['five'] = this.five;
        data['ten'] = this.ten;
        data['twenty'] = this.twenty;
        data['sixty'] = this.sixty;
        data['sixtyOnePlus'] = this.sixtyOnePlus;
        data['dataId'] = this.dataId;
        data['parentDataId'] = this.parentDataId;
        data['isCollapsable'] = this.isCollapsable;
        data['areCellsClickable'] = this.areCellsClickable;
        return data;
    }

    clone(): TicketStatusDashboardOutput {
        const json = this.toJSON();
        let result = new TicketStatusDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ITicketStatusDashboardOutput {
    ticketStatusId: number | undefined;
    ticketTypeId: number | undefined;
    userId: number | undefined;
    departmentId: number | undefined;
    userFullName: string | undefined;
    ticketTypeName: string | undefined;
    ticketStatusName: string | undefined;
    providerId: number | undefined;
    rowLabel: string | undefined;
    indent: number;
    one: number | undefined;
    three: number | undefined;
    five: number | undefined;
    ten: number | undefined;
    twenty: number | undefined;
    sixty: number | undefined;
    sixtyOnePlus: number | undefined;
    dataId: string;
    parentDataId: string | undefined;
    isCollapsable: boolean;
    areCellsClickable: boolean;
}

export class TicketStatusEditDto implements ITicketStatusEditDto {
    tenantId: number | undefined;
    name: string;
    departmentId: number;
    inProgress: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketStatusEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.departmentId = _data['departmentId'];
            this.inProgress = _data['inProgress'];
            this.isDefault = _data['isDefault'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketStatusEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketStatusEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['departmentId'] = this.departmentId;
        data['inProgress'] = this.inProgress;
        data['isDefault'] = this.isDefault;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketStatusEditDto {
        const json = this.toJSON();
        let result = new TicketStatusEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketStatusEditDto {
    tenantId: number | undefined;
    name: string;
    departmentId: number;
    inProgress: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketStatusListDto implements ITicketStatusListDto {
    name: string | undefined;
    departmentId: number;
    departmentName: string | undefined;
    inProgress: boolean;
    isDefault: boolean;
    id: number;

    constructor(data?: ITicketStatusListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
            this.inProgress = _data['inProgress'];
            this.isDefault = _data['isDefault'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketStatusListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketStatusListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        data['inProgress'] = this.inProgress;
        data['isDefault'] = this.isDefault;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketStatusListDto {
        const json = this.toJSON();
        let result = new TicketStatusListDto();
        result.init(json);
        return result;
    }
}

export interface ITicketStatusListDto {
    name: string | undefined;
    departmentId: number;
    departmentName: string | undefined;
    inProgress: boolean;
    isDefault: boolean;
    id: number;
}

export class TicketTypeAdminEditDto implements ITicketTypeAdminEditDto {
    name: string;
    departmentId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketTypeAdminEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.departmentId = _data['departmentId'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketTypeAdminEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketTypeAdminEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['departmentId'] = this.departmentId;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketTypeAdminEditDto {
        const json = this.toJSON();
        let result = new TicketTypeAdminEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketTypeAdminEditDto {
    name: string;
    departmentId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketTypeAdminListDto implements ITicketTypeAdminListDto {
    id: number;
    name: string | undefined;
    departmentId: number;
    departmentName: string | undefined;
    isDeleteable: boolean;

    constructor(data?: ITicketTypeAdminListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
            this.isDeleteable = _data['isDeleteable'];
        }
    }

    static fromJS(data: any): TicketTypeAdminListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketTypeAdminListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        data['isDeleteable'] = this.isDeleteable;
        return data;
    }

    clone(): TicketTypeAdminListDto {
        const json = this.toJSON();
        let result = new TicketTypeAdminListDto();
        result.init(json);
        return result;
    }
}

export interface ITicketTypeAdminListDto {
    id: number;
    name: string | undefined;
    departmentId: number;
    departmentName: string | undefined;
    isDeleteable: boolean;
}

export class TicketTypeEditDto implements ITicketTypeEditDto {
    id: number;
    name: string;

    constructor(data?: ITicketTypeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): TicketTypeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketTypeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }

    clone(): TicketTypeEditDto {
        const json = this.toJSON();
        let result = new TicketTypeEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketTypeEditDto {
    id: number;
    name: string;
}

export class TicketTypeListDto implements ITicketTypeListDto {
    name: string | undefined;
    departmentName: string | undefined;
    id: number;

    constructor(data?: ITicketTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.departmentName = _data['departmentName'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['departmentName'] = this.departmentName;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketTypeListDto {
        const json = this.toJSON();
        let result = new TicketTypeListDto();
        result.init(json);
        return result;
    }
}

export interface ITicketTypeListDto {
    name: string | undefined;
    departmentName: string | undefined;
    id: number;
}

export class TicketWorkflowAutomation implements ITicketWorkflowAutomation {
    tenantId: number | undefined;
    departmentId: number;
    department: Department;
    currentStatusId: number;
    currentStatus: TicketStatus;
    newStatusId: number;
    newStatus: TicketStatus;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    readonly departmentName: string | undefined;
    readonly currentStatusName: string | undefined;
    readonly newStatusName: string | undefined;
    readonly creatorUserName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketWorkflowAutomation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.departmentId = _data['departmentId'];
            this.department = _data['department'] ? Department.fromJS(_data['department']) : <any>undefined;
            this.currentStatusId = _data['currentStatusId'];
            this.currentStatus = _data['currentStatus'] ? TicketStatus.fromJS(_data['currentStatus']) : <any>undefined;
            this.newStatusId = _data['newStatusId'];
            this.newStatus = _data['newStatus'] ? TicketStatus.fromJS(_data['newStatus']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creatorUser = _data['creatorUser'] ? User.fromJS(_data['creatorUser']) : <any>undefined;
            (<any>this).departmentName = _data['departmentName'];
            (<any>this).currentStatusName = _data['currentStatusName'];
            (<any>this).newStatusName = _data['newStatusName'];
            (<any>this).creatorUserName = _data['creatorUserName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketWorkflowAutomation {
        data = typeof data === 'object' ? data : {};
        let result = new TicketWorkflowAutomation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['departmentId'] = this.departmentId;
        data['department'] = this.department ? this.department.toJSON() : <any>undefined;
        data['currentStatusId'] = this.currentStatusId;
        data['currentStatus'] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
        data['newStatusId'] = this.newStatusId;
        data['newStatus'] = this.newStatus ? this.newStatus.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creatorUser'] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data['departmentName'] = this.departmentName;
        data['currentStatusName'] = this.currentStatusName;
        data['newStatusName'] = this.newStatusName;
        data['creatorUserName'] = this.creatorUserName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketWorkflowAutomation {
        const json = this.toJSON();
        let result = new TicketWorkflowAutomation();
        result.init(json);
        return result;
    }
}

export interface ITicketWorkflowAutomation {
    tenantId: number | undefined;
    departmentId: number;
    department: Department;
    currentStatusId: number;
    currentStatus: TicketStatus;
    newStatusId: number;
    newStatus: TicketStatus;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creatorUser: User;
    departmentName: string | undefined;
    currentStatusName: string | undefined;
    newStatusName: string | undefined;
    creatorUserName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketWorkflowAutomationDto implements ITicketWorkflowAutomationDto {
    tenantId: number | undefined;
    departmentId: number;
    departmentName: string | undefined;
    currentStatusId: number;
    currentStatusName: string | undefined;
    newStatusId: number;
    newStatusName: string | undefined;
    creatorUserName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITicketWorkflowAutomationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.departmentId = _data['departmentId'];
            this.departmentName = _data['departmentName'];
            this.currentStatusId = _data['currentStatusId'];
            this.currentStatusName = _data['currentStatusName'];
            this.newStatusId = _data['newStatusId'];
            this.newStatusName = _data['newStatusName'];
            this.creatorUserName = _data['creatorUserName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): TicketWorkflowAutomationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketWorkflowAutomationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['departmentId'] = this.departmentId;
        data['departmentName'] = this.departmentName;
        data['currentStatusId'] = this.currentStatusId;
        data['currentStatusName'] = this.currentStatusName;
        data['newStatusId'] = this.newStatusId;
        data['newStatusName'] = this.newStatusName;
        data['creatorUserName'] = this.creatorUserName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): TicketWorkflowAutomationDto {
        const json = this.toJSON();
        let result = new TicketWorkflowAutomationDto();
        result.init(json);
        return result;
    }
}

export interface ITicketWorkflowAutomationDto {
    tenantId: number | undefined;
    departmentId: number;
    departmentName: string | undefined;
    currentStatusId: number;
    currentStatusName: string | undefined;
    newStatusId: number;
    newStatusName: string | undefined;
    creatorUserName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TicketWorkflowAutomationEditDto implements ITicketWorkflowAutomationEditDto {
    id: number | undefined;
    departmentId: number;
    currentStatusId: number;
    newStatusId: number;

    constructor(data?: ITicketWorkflowAutomationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.departmentId = _data['departmentId'];
            this.currentStatusId = _data['currentStatusId'];
            this.newStatusId = _data['newStatusId'];
        }
    }

    static fromJS(data: any): TicketWorkflowAutomationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TicketWorkflowAutomationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['departmentId'] = this.departmentId;
        data['currentStatusId'] = this.currentStatusId;
        data['newStatusId'] = this.newStatusId;
        return data;
    }

    clone(): TicketWorkflowAutomationEditDto {
        const json = this.toJSON();
        let result = new TicketWorkflowAutomationEditDto();
        result.init(json);
        return result;
    }
}

export interface ITicketWorkflowAutomationEditDto {
    id: number | undefined;
    departmentId: number;
    currentStatusId: number;
    newStatusId: number;
}
